<template>
    <div>
        <div class="container" v-if="ListGarantidorasGeral!=''">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">Contratação com vigência finalizada</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"><router-link to="/home"><i class="fa fa-home"></i></router-link></li>
                        <li class="separator"><i class="fa fa-chevron-right"></i></li>
                        <li class="nav-item"><router-link to="/ListaContratacoesVigenciaFinalizada">Contratações</router-link></li>
                        <li class="separator"><i class="fa fa-chevron-right"></i></li>
                        <li class="nav-item"><span>Contratação com vigência finalizada</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card gp-contract-detail-card">
                            <div class="card-header">
                                <div class="d-flex align-items-center gp-finalizada-heading">
                                    <div>
                                        <h4 class="card-title">Contratação {{ PedidosCli.pedId }}</h4>
                                        <small>Acompanhamento da garantia locatícia</small>
                                        <span v-if="PedidosCli?.cusNome"><v-icon size="14">mdi-account-outline</v-icon>Usuário: {{ PedidosCli.cusNome }}</span>
                                    </div>
                                    <span class="gp-finalizada-status"><v-icon size="15">mdi-calendar-check-outline</v-icon>{{ PedidosCli.pedSituacaoPedido || 'Vigência finalizada' }}</span>
                                </div>
                            </div>
                            <div class="card-body">
                                <section v-if="PedidosCli != ''" class="gp-finalizada-overview">
                                    <div class="gp-finalizada-overview-main">
                                        <div class="gp-finalizada-access"><small>Cliente</small><strong>{{ Cliente.cliNomeEmpresa || '—' }}</strong><span>{{ Cliente.cliDocumento || 'Documento não informado' }}</span><button v-if="Cliente.cliId" type="button" @click="openDialogCliente(Cliente.cliId)"><v-icon size="17">mdi-folder-open</v-icon></button></div>
                                        <div class="gp-finalizada-access"><small>Garantidora / Imobiliária</small><strong>{{ DadosGarantidora.garNomeEmpresa || '—' }}</strong><span>{{ Imobiliaria.imoNomeEmpresa || '—' }}</span><button v-if="Imobiliaria.imoId" type="button" @click="openDialogImobiliaria(Imobiliaria.imoId)"><v-icon size="17">mdi-folder-open</v-icon></button></div>
                                        <div><small>Valor contratado</small><strong class="gp-finalizada-value">R$ {{ formatarValor(PedidosCli.pedValorTotalPedido || TotalPedido || 0) }}</strong><span>{{ PedidosCli.pedCiclo > 1 ? `Renovação · ciclo ${PedidosCli.pedCiclo}` : 'Contratação inicial' }}</span></div>
                                        <div><small>Vigência</small><strong>{{ ListaPedidoItem.length ? formattedDate(ListaPedidoItem[0].pdiDataVigenciaIni) : '—' }}</strong><span>até {{ ListaPedidoItem.length ? formattedDate(ListaPedidoItem[0].pdiDataVigenciaFim) : '—' }}</span></div>
                                    </div>
                                    <div class="gp-finalizada-context-grid">
                                        <article><header><v-icon size="17">mdi-map-marker-outline</v-icon><strong>Endereço da contratação</strong></header><template v-if="PedidosEndereco?.length"><strong>{{ PedidosEndereco[0].pdcEndereco }}, {{ PedidosEndereco[0].pdcNumero }}<template v-if="PedidosEndereco[0].pdcComplemento"> - {{ PedidosEndereco[0].pdcComplemento }}</template></strong><span>{{ PedidosEndereco[0].pdcBairro }} · {{ PedidosEndereco[0].pdcCidade }}/{{ PedidosEndereco[0].pdcEstado }} · CEP {{ PedidosEndereco[0].pdcCep }}</span><small>{{ PedidosEndereco[0].pdcTipo }} {{ PedidosEndereco[0].pdcResidencialTipo }}</small></template><span v-else>Endereço não informado.</span></article>
                                        <article class="gp-finalizada-products"><header><v-icon size="17">mdi-shield-home-outline</v-icon><strong>Produtos e garantia</strong></header><div v-for="produto in ListaPedidoItem" :key="`finalizada-${produto.pdiId}`" class="gp-finalizada-product-row"><div><strong>{{ produto.pdiNomeProduto }}</strong><span>Código {{ produto.proId }}</span></div><div class="gp-finalizada-product-config"><span><small>Cobertura</small><strong>{{ CoberturaProduto(produto) }}</strong></span><span><small>Setup</small><strong>R$ {{ formatarValor(produto.pdiCampoExtra1 || 0) }}</strong></span><span v-if="User.tpeid != 3"><small>Taxa</small><strong>{{ formatarTaxa(produto.pdiCampoExtra2) }}</strong></span></div></div><div v-if="ListaPedidoItemAdicional.length" class="gp-finalizada-additionals"><span v-for="sub in ListaPedidoItemAdicional" :key="sub.piaId">+ {{ sub.piaNomeProduto }} · R$ {{ formatarValor(sub.piaValorTotalProduto) }}</span></div></article>
                                    </div>
                                    <div class="gp-finalizada-section-nav">
                                        <button v-if="User.tpeid != 3" type="button" :class="{ 'is-active': secaoFinalizada === 'analise' }" @click="AbrirSecaoFinalizada('analise')"><v-icon size="16">mdi-account-search-outline</v-icon>Análise</button>
                                        <button type="button" :class="{ 'is-active': secaoFinalizada === 'observacoes' }" @click="AbrirSecaoFinalizada('observacoes')"><v-icon size="16">mdi-message-text-outline</v-icon>Observações</button>
                                        <button v-if="ListDocumentosAss?.length" type="button" :class="{ 'is-active': secaoFinalizada === 'contrato' }" @click="AbrirSecaoFinalizada('contrato')"><v-icon size="16">mdi-file-document-outline</v-icon>Contrato</button>
                                        <button type="button" :class="{ 'is-active': secaoFinalizada === 'pagamento' }" @click="AbrirSecaoFinalizada('pagamento')"><v-icon size="16">mdi-credit-card-outline</v-icon>Pagamento</button>
                                        <button type="button" :class="{ 'is-active': secaoFinalizada === 'documentos' }" @click="AbrirSecaoFinalizada('documentos')"><v-icon size="16">mdi-folder-outline</v-icon>Documentos</button>
                                        <button v-if="ListaDocs.length" type="button" :class="{ 'is-active': secaoFinalizada === 'docs' }" @click="AbrirSecaoFinalizada('docs')"><v-icon size="16">mdi-file-account-outline</v-icon>Documentos do cliente</button>
                                        <button v-if="ListaConsultas.length && User.tpeid != 3" type="button" :class="{ 'is-active': secaoFinalizada === 'consultas' }" @click="AbrirSecaoFinalizada('consultas')"><v-icon size="16">mdi-magnify</v-icon>Consultas</button>
                                    </div>
                                </section>

                                <div class="gp-finalizada-panels">
                                    <section v-if="secaoFinalizada === 'analise' && User.tpeid != 3" class="gp-finalizada-analysis-grid">
                                        <article v-for="itemAnalise in analisesCredito" :key="itemAnalise.titulo" class="gp-finalizada-analysis-card"><header><strong>{{ itemAnalise.titulo }}</strong><span>Somente visualização</span></header><div><strong>{{ itemAnalise.nome || 'Não cadastrado' }}</strong><small>{{ itemAnalise.documento || 'Documento não informado' }}</small></div><VueSpeedometer :value="getScoreConsulta(itemAnalise.consultas)" :minValue="0" :maxValue="1000" segments="5" :width="180" :height="150" needleColor="steelblue"/><footer><button v-if="getConsulta(itemAnalise.consultas, 'ser')?.retorno && !isRetornoCpfNotAvailable(getConsulta(itemAnalise.consultas, 'ser'))" type="button" @click="CarregaModalSerasaCredito(getConsulta(itemAnalise.consultas, 'ser').retorno)">Crédito</button><button v-if="getConsulta(itemAnalise.consultas, 'jus')?.retorno && !isRetornoCpfNotAvailable(getConsulta(itemAnalise.consultas, 'jus'))" type="button" @click="CarregaModalJusCredito(getConsulta(itemAnalise.consultas, 'jus').retorno)">Jurídica</button><button v-if="getConsulta(itemAnalise.consultas, 'cdl')?.retorno && !isRetornoCpfNotAvailable(getConsulta(itemAnalise.consultas, 'cdl'))" type="button" @click="CarregaModalCdlCredito(getConsulta(itemAnalise.consultas, 'cdl').retorno)">Complementar</button></footer></article>
                                    </section>

                                    <section v-if="secaoFinalizada === 'observacoes'" class="gp-finalizada-read-panel"><header><span><v-icon size="19">mdi-message-text-outline</v-icon></span><div><strong>Observações da contratação</strong><small>Registros dos diferentes participantes do processo.</small></div><em><v-icon size="14">mdi-lock-outline</v-icon>Somente visualização</em></header><div class="gp-finalizada-observations"><article><small>Análise</small><p>{{ PedidosCli.pedObsAnalise || 'Nenhuma observação.' }}</p></article><article v-if="User.tpeid != 3"><small>Interna</small><p>{{ PedidosCli.pedObsLoja || 'Nenhuma observação.' }}</p></article><article><small>Cliente / imobiliária</small><p>{{ PedidosCli.pedObsCliente || 'Nenhuma observação.' }}</p></article></div></section>

                                    <section v-if="secaoFinalizada === 'contrato'" class="gp-finalizada-read-panel"><header><span><v-icon size="19">mdi-file-document-outline</v-icon></span><div><strong>Contrato</strong><small>Documentos contratuais vinculados a esta vigência.</small></div><em><v-icon size="14">mdi-lock-outline</v-icon>Somente visualização</em></header><div v-if="ListDocumentosAss?.length" class="gp-finalizada-contract-list"><div v-for="item in ListDocumentosAss" :key="item.pftId"><span><v-icon size="20">mdi-file-pdf-box</v-icon></span><div><strong>Contrato da contratação {{ PedidosCli.pedId }}</strong><small>{{ item.pftUrlDocAssinado ? 'Contrato assinado disponível' : 'Documento original' }}</small></div><button v-if="item.pftUrlImagem" type="button" @click="VisualizarDocumento(item.pftUrlImagem)"><v-icon size="16">mdi-file-eye-outline</v-icon>Original</button><button v-if="item.pftUrlDocAssinado" type="button" @click="VisualizarDocumento(item.pftUrlDocAssinado)"><v-icon size="16">mdi-file-check-outline</v-icon>Assinado</button></div></div><div v-else class="gp-finalizada-empty"><v-icon size="26">mdi-file-document-remove-outline</v-icon><strong>Nenhum contrato vinculado</strong></div></section>

                                    <section v-if="secaoFinalizada === 'pagamento'" class="gp-finalizada-read-panel"><header><span><v-icon size="19">mdi-credit-card-outline</v-icon></span><div><strong>Pagamento da contratação</strong><small>Condição registrada para esta vigência.</small></div><em><v-icon size="14">mdi-lock-outline</v-icon>Somente visualização</em></header><div class="gp-finalizada-payment-summary"><article><small>Entrada</small><strong>{{ Number(PedidosCli.pedValorEntrada || 0) > 0 ? `R$ ${formatarValor(PedidosCli.pedValorEntrada)}` : 'Sem entrada' }}</strong><span>{{ PedidosCli.pedFormaPgtoEntrada || PedidosCli.pedFormaPgto || '—' }}</span></article><article><small>Saldo parcelado</small><strong>{{ PedidosCli.pedQtdeParcelas || 0 }}x de R$ {{ formatarValor(PedidosCli.pedValorParcelas || 0) }}</strong><span>{{ PedidosCli.pedFormaPgtoParcelas || PedidosCli.pedFormaPgto || '—' }}</span></article><article><small>Setup</small><strong>R$ {{ formatarValor(ListaPedidoItem?.[0]?.pdiCampoExtra1 || 0) }}</strong><span>{{ Number(PedidosCli.pedSetupEntrada) === 1 ? 'Incluído na entrada' : 'Distribuído no saldo' }}</span></article></div></section>

                                    <section v-if="secaoFinalizada === 'documentos'" class="gp-finalizada-read-panel"><header><span><v-icon size="19">mdi-folder-outline</v-icon></span><div><strong>Documentos da contratação</strong><small>Arquivos enviados durante o processo.</small></div><em><v-icon size="14">mdi-lock-outline</v-icon>Somente visualização</em></header><div v-if="uniqueDocumentos.length" class="gp-finalizada-document-list"><div v-for="item in uniqueDocumentos" :key="item.pmsId"><v-icon size="19">mdi-file-outline</v-icon><strong>{{ item.pmsNome }}</strong><button v-if="item.pmsUrlImagem" type="button" @click="VisualizarDocumento(item.pmsUrlImagem)"><v-icon size="16">mdi-file-eye-outline</v-icon>Visualizar</button></div></div><div v-else class="gp-finalizada-empty"><v-icon size="26">mdi-folder-off-outline</v-icon><strong>Nenhum documento vinculado</strong></div></section>

                                    <section v-if="secaoFinalizada === 'docs'" class="gp-finalizada-read-panel"><header><span><v-icon size="19">mdi-file-account-outline</v-icon></span><div><strong>Documentos do cliente</strong><small>Arquivos existentes no cadastro do cliente.</small></div><em><v-icon size="14">mdi-lock-outline</v-icon>Somente visualização</em></header><div class="gp-finalizada-document-list"><div v-for="item in ListaDocs" :key="item.cdsId"><v-icon size="19">mdi-file-account-outline</v-icon><div><strong>{{ item.cdsNomeDoc }}</strong><small>{{ formattedDate(item.cdsDataCadastro) }}</small></div><button v-if="item.cdsUrlDoc" type="button" @click="VisualizarDocumento(item.cdsUrlDoc)"><v-icon size="16">mdi-file-eye-outline</v-icon>Visualizar</button></div></div></section>

                                    <section v-if="secaoFinalizada === 'consultas' && User.tpeid != 3" class="gp-finalizada-read-panel"><header><span><v-icon size="19">mdi-magnify</v-icon></span><div><strong>Consultas de crédito</strong><small>Consultas realizadas no cadastro do cliente.</small></div><em><v-icon size="14">mdi-lock-outline</v-icon>Somente visualização</em></header><div class="gp-finalizada-document-list"><div v-for="item in ListaConsultas" :key="item.ccsId"><v-icon size="19">mdi-database-search-outline</v-icon><div><strong>{{ item.cliNome }} · {{ item.cliTipo }}</strong><small>{{ formattedDate(item.ccsDataConsulta) }} · Score {{ item.ccsScore }}</small></div><button type="button" @click="CarregaModalSerasa(item)">Crédito</button><button type="button" @click="CarregaModalJus(item)">Jurídica</button></div></div></section>
                                </div>

                                <div v-if="Number(PedidosCli.pspId) === 10" class="gp-finalizada-actions"><button v-if="User.garid == 0 || [1, 3].includes(Number(User.tpeid))" type="button" class="is-renew" @click="PutSituacao(11)"><v-icon size="16">mdi-autorenew</v-icon>Renovar vigência</button><button type="button" class="is-close" @click="CancelarVigencia()"><v-icon size="16">mdi-calendar-remove-outline</v-icon>Encerrar vigência</button></div>

                                <v-tabs v-if="false" v-model="tab" class="gp-client-tabs" color="#102a5a" show-arrows>
                                <v-tab value="dados" class="tabinfo"><v-icon size="16">mdi-file-document-outline</v-icon> Detalhe da contratação</v-tab>
                                <v-tab value="documentos" class="tabinfo"><v-icon size="16">mdi-folder-outline</v-icon> Documentos</v-tab>
                                 <v-tab v-if="ListaDocs.length > 0" value="docs" class="tabinfo"><v-icon size="16">mdi-file-account-outline</v-icon> Documentos do cliente</v-tab>
                                 <v-tab v-if="ListaConsultas.length > 0 && User.tpeid != 3" value="consulta" class="tabinfo"><v-icon size="16">mdi-magnify</v-icon> Consultas de crédito</v-tab>
                                </v-tabs>
                                <v-window v-if="false" v-model="tab">
                                    <v-window-item value="dados">
                                        <v-form>
                                            <v-container v-if="PedidosCli != '' && PedidosEndereco != ''">
                                                <v-row>
                                                    <v-col cols="12" md="5">
                                                        <v-row>
                                                            <v-col cols="12" md="12">
                                                                <v-card style="padding: 15px;" color="#f7f7f7">
                                                                    <div>
                                                                        <h5 class="subtitulo" style="padding-bottom: 15px;">Endereço Contratação
                                                                        </h5>
                                                                        <p class="texto-mensagem mb-0" style="color:#333333;font-size: 14px;">
                                                                            <strong>Endereço:</strong> {{
                                                                                            PedidosEndereco[0].pdcEndereco
                                                                                        }}, {{ PedidosEndereco[0].pdcNumero }} - {{
                                                                                            PedidosEndereco[0].pdcComplemento }}
                                                                        </p>
                                                                        <p class="texto-mensagem mb-0" style="color:#333333;font-size: 14px;">
                                                                            <strong>Cidade/UF:</strong> {{
                                                                                                    PedidosEndereco[0].pdcCidade }} /
                                                                            {{ PedidosEndereco[0].pdcEstado }}
                                                                        </p>
                                                                        <p class="texto-mensagem mb-0" style="color:#333333;font-size: 14px;">
                                                                            <strong>Bairro:</strong> {{ PedidosEndereco[0].pdcBairro
                                                                            }}
                                                                        </p>
                                                                        <p class="texto-mensagem mb-0" style="color:#333333;font-size: 14px;">
                                                                            <strong>CEP:</strong> {{ PedidosEndereco[0].pdcCep }}
                                                                        </p>
                                                                        <p class="texto-mensagem mb-0" style="color:#333333;font-size: 14px;">
                                                                            <strong>Tipo Imóvel:</strong> {{ PedidosEndereco[0].pdcTipo
                                                                            }} {{ PedidosEndereco[0].pdcResidencialTipo }}
                                                                        </p>
                                                                    </div>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                    <v-col cols="12" md="7">
                                                        <v-row>
                                                            <v-col cols="12" md="12">
                                                                <v-card style="padding: 15px;min-height: 215px;" color="#f7f7f7">
                                                                    <div>
                                                                        <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                            Informações Contratação</h5>
                                                                        <h6 class="mb-0"><strong>Contratação: {{ PedidosCli.pedId }}</strong></h6>
                                                                        <div class="pedido_dados" v-if="PedidosCli.pedCiclo > 1"><strong>Renovação:  {{ PedidosCli.pedCodigoContratacao }} - Ciclo: {{ PedidosCli.pedCiclo }}</strong></div>
                                                                        <div class="pedido_dados"><strong>Garantidora:</strong> {{ DadosGarantidora.garNomeEmpresa }}</div>
                                                                        <div class="pedido_dados"><strong>Imobiliária:</strong> {{ Imobiliaria.imoNomeEmpresa }} - {{ Imobiliaria.imoEmail }} <v-icon @click="openDialogImobiliaria(Imobiliaria.imoId)">mdi-folder-open</v-icon> </div>
                                                                        <div class="pedido_dados"><strong>Cliente:</strong> {{ Cliente.cliNomeEmpresa }} - {{ Cliente.cliEmail }}  <v-icon @click="openDialogCliente(Cliente.cliId)">mdi-folder-open</v-icon></div>
                                                                        <div class="pedido_dados"><strong>Data :</strong> {{ formattedDate(PedidosCli.pedDataPedido) }}</div>
                                                                          <div class="pedido_dados"
                                                                            v-if="ListDocumentosAss != null && ListDocumentosAss.length > 0">
                                                                            <div v-if="ListDocumentosAss[0].pftUrlDocAssinado != '' && ListDocumentosAss[0].pftUrlDocAssinado != null">
                                                                                <strong>Contrato Assinado:</strong> 
                                                                                <a @click.prevent="VisualizarDocumento(ListDocumentosAss[0].pftUrlDocAssinado)" style="cursor: pointer;">
                                                                                    Clique para visualizar
                                                                                </a>
                                                                            </div>
                                                                              <div v-if="ListDocumentosAss[0].pftUrlImagem != '' && ListDocumentosAss[0].pftUrlImagem != null">
                                                                                <strong>Contrato Original:</strong> 
                                                                                <a @click.prevent="VisualizarDocumento(ListDocumentosAss[0].pftUrlImagem)" style="cursor: pointer;">
                                                                                    Clique para visualizar
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                        <div class="pedido_dados" v-if="PedidosCli.pedFormaPgto!=''">
                                                                            <strong>Forma de Pgto:</strong> {{
                                                                            PedidosCli.pedFormaPgto }}
                                                                            
                                                                        </div>
                                                                        <div class="pedido_dados" style="display: inline-flex;" v-if="PedidosCli.pedSetupEntrada!=null && PedidosCli.pedTipoPgto == 3">
                                                                            <strong>Parcelamento:</strong> 
                                                                            <div v-if="PedidosCli.pedSetupEntrada == 1">R$ {{ formatarValor(PedidosCli.pedValorEntrada) }} + {{ PedidosCli.pedQtdeParcelas }}x de R$ {{ formatarValor(PedidosCli.pedValorParcelas) }}</div>
                                                                            <div v-if="PedidosCli.pedSetupEntrada == 0">{{ PedidosCli.pedQtdeParcelas }}x de R$ {{ formatarValor(PedidosCli.pedValorParcelas) }}</div>
                                                                        </div>
                                                                    </div>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="12">
                                                        <v-row>
                                                            <v-col cols="12" md="12">
                                                                <v-card style="padding: 25px;" color="#f9f9f9">
                                                                    <div>
                                                                        <h5 class="subtitulo" style="padding-bottom: 15px;">Produto</h5>
                                                                        <div v-for="produto in ListaPedidoItem" :key="produto.pdiId"
                                                                            class="descricao-pedido border-top py-3">
                                                                            <div class="row">
                                                                                <div v-if="ListaProdutosImg!=''"
                                                                                    class="col-3 col-md-2 d-flex align-items-center justify-content-center">
                                                                                    <div class="descricao-img">
                                                                                        <img  v-if="ListaProdutosImg.filter(x=> x.proId === produto.proId) != ''" :src="buildFileUrl(ListaProdutosImg.filter(x=> x.proId == produto.proId)[0].pimUrlImagem)"  class="img-fluid border border-rounded mb-3 mb-md-0"/>
                                                                                        <img v-else class="img-fluid border border-rounded mb-3 mb-md-0"
                                                                                            src="/imagens/indisponivel.jpg"
                                                                                            alt="">
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    class="col-6 col-md-5 d-flex align-items-center">
                                                                                    <div class="descricao-content">
                                                                                        <h6 class="subtitulo" >{{produto.pdiNomeProduto}}</h6>
                                                                                        <p class="texto-mensagem" style="margin: 0 0 0px"> Código: {{produto.proId }}</p>
                                                                                        <p class="texto-mensagem" style="margin: 0 0 0px; display: inline-flex;"> 
                                                                                            <v-text-field v-model="produto.pdiDataVigenciaIni" type="date" disabled label="Data Vigência Inicial:" variant="underlined" style="padding-right: 15px;"></v-text-field>
                                                                                            <v-text-field v-model="produto.pdiDataVigenciaFim" type="date" disabled label="Data Vigência Final:" variant="underlined"></v-text-field> 
                                                                                        </p>
                                                                                        <p class="texto-mensagem" style="margin: 0 0 0px"> Setup: R$ {{ formatarValor(produto.pdiCampoExtra1) }}</p>
                                                                                        <p class="texto-mensagem" style="margin: 0 0 0px" v-if="User.tpeid != 3"> Taxa: {{produto.pdiCampoExtra2 }}</p>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-6 col-md-3 d-flex align-items-center">
                                                                                    <ul>
                                                                                        <li v-for="(sub,index) in ListaPedidoItemAdicional" :key="index" style="font-size: 12px;"> 
                                                                                        {{ sub.piaNomeProduto }} - R$ {{ formatarValor(sub.piaValorTotalProduto) }}
                                                                                        </li>
                                                                                    </ul>
                                                                                </div>
                                                                                <div
                                                                                    class="col-6 col-md-2 d-flex align-items-center">
                                                                                    <div class="descricao-content">
                                                                                        <h6 class="subtitulo"
                                                                                            style="font-size: 15px;">
                                                                                            R$ {{
                                                                                            parseFloat(produto.pdiValorTotalProduto).toFixed(2).toString().replace('.',
                                                                                            ',')
                                                                                            }}</h6>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12" md="12">
                                                                <v-card style="padding: 25px;" color="#f7f7f7">
                                                                    <div>
                                                                        <div
                                                                            class="d-flex align-items-center justify-content-between">
                                                                            <h5 class="subtitulo">Total</h5>
                                                                            <h6 class="subtitulo">R$ {{
                                                                                parseFloat(TotalPedido).toFixed(2).toString().replace('.',
                                                                                ',')
                                                                                }}</h6>
                                                                        </div>
                                                                    </div>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-if="User.tpeid != 3">
                                                    <v-col cols="12" md="3" style="text-align:center;" v-for="itemAnalise in analisesCredito" :key="itemAnalise.titulo">
                                                        <v-card style="padding: 25px;margin-top: 30px;" color="#f7f7f7">
                                                            <h5 class="subtitulo" style="padding-bottom: 15px;">{{ itemAnalise.titulo }}</h5>
                                                            <div style="min-height: 50px;">
                                                                <div>{{ itemAnalise.nome || 'Não Cadastrado' }}</div>
                                                                <div>{{ itemAnalise.documento }}</div>
                                                            </div>
                                                            <v-row style="padding-top: 25px;justify-content: center;">
                                                                <VueSpeedometer :value="getScoreConsulta(itemAnalise.consultas)" :minValue="0" :maxValue="1000" segments="5" :width="200" :height="180" needleColor="steelblue" />
                                                            </v-row>
                                                            <button type="button" class="btn btn-info" v-if="getConsulta(itemAnalise.consultas, 'ser')?.retorno && !isRetornoCpfNotAvailable(getConsulta(itemAnalise.consultas, 'ser'))" @click="CarregaModalSerasaCredito(getConsulta(itemAnalise.consultas, 'ser').retorno)" style="color:#ffffff;margin:5px;padding:10px;">Análise Crédito</button>
                                                            <div v-else-if="getConsulta(itemAnalise.consultas, 'ser')?.retorno && isRetornoCpfNotAvailable(getConsulta(itemAnalise.consultas, 'ser'))" class="text-danger" style="padding:10px;margin:5px;">CPF NAO DISPONIVEL</div>
                                                            <button type="button" class="btn btn-info" v-if="!getConsulta(itemAnalise.consultas, 'ser')?.retorno && getConsulta(itemAnalise.consultas, 'cdl')?.retorno && !isRetornoCpfNotAvailable(getConsulta(itemAnalise.consultas, 'cdl'))" @click="CarregaModalSerasaCredito2(getConsulta(itemAnalise.consultas, 'cdl').retorno)" style="color:#ffffff;margin:5px;padding:10px;">Análise Crédito</button>
                                                            <button type="button" class="btn btn-info" v-if="getConsulta(itemAnalise.consultas, 'cdl')?.retorno && !isRetornoCpfNotAvailable(getConsulta(itemAnalise.consultas, 'cdl'))" @click="CarregaModalCdlCredito(getConsulta(itemAnalise.consultas, 'cdl').retorno)" style="color:#ffffff;margin:5px;padding:10px;">Complementar</button>
                                                            <div v-else-if="getConsulta(itemAnalise.consultas, 'cdl')?.retorno && isRetornoCpfNotAvailable(getConsulta(itemAnalise.consultas, 'cdl'))" class="text-danger" style="padding:10px;margin:5px;">CPF NAO DISPONIVEL</div>
                                                            <button type="button" class="btn btn-info" v-if="getConsulta(itemAnalise.consultas, 'jus')?.retorno && !isRetornoCpfNotAvailable(getConsulta(itemAnalise.consultas, 'jus'))" @click="CarregaModalJusCredito(getConsulta(itemAnalise.consultas, 'jus').retorno)" style="color:#ffffff;margin:5px;padding:10px;">Análise Jurídica</button>
                                                            <div style="padding-top: 10px;text-align:left;">
                                                                {{ getObsConsulta(itemAnalise.consultas, 'ser', 'Crédito') }}<br/>
                                                                {{ getObsConsulta(itemAnalise.consultas, 'jus', 'Jurídica') }}<br/>
                                                                {{ getObsConsulta(itemAnalise.consultas, 'cdl', 'Complementar') }}
                                                            </div>
                                                        </v-card>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="12">
                                                        <v-card style="padding: 25px;" color="#f7f7f7">
                                                            <div>
                                                                <h5 class="subtitulo" style="padding-bottom: 15px;">Situação Atual: {{PedidosCli.pedSituacaoPedido}}
                                                                </h5>
                                                                <v-row v-if="User.tpeid != 3" style="padding-top: 20px">
                                                                    <label>Observações Internas</label>
                                                                    <textarea disabled cols="12" rows="5"  class="form-control" v-model="PedidosCli.pedObsLoja" label="Observações"></textarea>
                                                                </v-row>
                                                                <v-row style="padding-top: 20px">
                                                                    <label>Observações</label>
                                                                    <textarea disabled cols="12" rows="5"  class="form-control" v-model="PedidosCli.pedObsAnalise" label="Observações"></textarea>
                                                                </v-row>
                                                                <v-row style="padding-top: 20px">
                                                                    <label>Observações Cliente</label>
                                                                    <textarea disabled cols="12" rows="5"  class="form-control" v-model="PedidosCli.pedObsCliente" label="Observações"></textarea>
                                                                </v-row>
                                                            </div>
                                                        </v-card>
                                                    </v-col>
                                                </v-row>
                                                <v-row  v-if="PedidosCli.pspId == 10" style="justify-content: center;padding-top: 15px;"> 
                                                            <button v-if="User.garid == 0 || [1, 3].includes(Number(User.tpeid))" type="button" class="btn btn-success"
                                                            style="color:#ffffff;margin: 5px;padding:10px;"
                                                            @click="PutSituacao(11)">
                                                            Renovar Vigência
                                                        </button>
                                                            <button type="button" class="btn btn-danger"
                                                            style="color:#ffffff;margin: 5px;padding:10px;"
                                                            @click="CancelarVigencia()">
                                                            Encerrar contratação
                                                        </button>
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                    <v-window-item value="documentos" >
                                        <v-form>
                                            <v-form>
                                                <v-container>
                                                <v-row>
                                                    <v-col cols="12" md="3">
                                                        <label>Nome Documento</label>
                                                        <input v-model="nomeDocumento" type="text" class="form-control" placeholder="Nome Documento" />
                                                    </v-col>
                                                    <v-col cols="12" md="5">
                                                        <label for="exampleFormControlFile1">*JPG, JPEG, PNG ou PDF</label>
                                                        <v-file-input v-model="selectedFile" label="Selecione o arquivo" variant="underlined" prepend-icon="mdi-file" accept="image/*,application/pdf"></v-file-input>
                                                    </v-col>
                                                    <v-col cols="12" md="3">
                                                        <a href="" class="btn btn-info" @click.prevent="EnviarDocumento()" style="color:#ffffff;">
                                                            Enviar
                                                        </a>
                                                    </v-col>
                                                </v-row>
                                                    <v-row>
                                                        <v-table>
                                                            <thead>
                                                            <tr>
                                                                <th class="text-left">
                                                                Documento
                                                                </th>
                                                                <th class="text-left">
                                                                Visualização
                                                                </th>
                                                                <th class="text-left">
                                                                Excluir
                                                                </th>
                                                              </tr>
                                                            </thead>
                                                            <tbody >
                                                            <tr v-for="item in ListDocumentos" :key="item.pmsId">
                                                                <td>{{ item.pmsNome }}</td>
                                                                <td style="text-align: center;">
                                                                    <v-btn v-if="item.pmsUrlImagem != ''" icon @click.prevent="VisualizarDocumento(item.pmsUrlImagem)"
                                                                        variant="text">
                                                                        <v-icon>mdi-file-eye</v-icon>
                                                                        <v-tooltip activator="parent"
                                                                            location="top">Visualizar</v-tooltip>
                                                                    </v-btn>
                                                                </td>
                                                                <td>
                                                                    <v-btn v-if="User.tpeid != 3" v-show="false" icon
                                                                        @click.prevent="DeleteDocumento(item)"
                                                                        variant="text">
                                                                        <v-icon>mdi-delete-forever-outline</v-icon>
                                                                        <v-tooltip activator="parent"
                                                                            location="top">Excluir</v-tooltip>
                                                                    </v-btn>
                                                                </td>
                                                            </tr>
                                                            </tbody>
                                                        </v-table>
                                                    </v-row>
                                                </v-container>
                                            </v-form>
                                        </v-form>
                                    </v-window-item>
                                     <!--Docs-->
                                    <v-window-item value="docs">
                                        <div style="padding-top: 20px;padding-bottom: 10px;padding-left: 20px;">
                                           Documentos inseridos no cadastro do cliente </div>
                                        <v-form>
                                                <v-container>
                                                    <v-row>
                                                        <v-table>
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">
                                                                        Documento
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Cadastro
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Visualização
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="item in ListaDocs" :key="item.cdsId">
                                                                    <td>{{ item.cdsNomeDoc }}</td>
                                                                    <td>{{ formattedDate(item.cdsDataCadastro) }}</td>
                                                                    <td style="text-align: center;">
                                                                        <v-btn v-if="item.cdsUrlDoc != ''" icon
                                                                            @click.prevent="VisualizarDocumento(item.cdsUrlDoc)"
                                                                            variant="text">
                                                                            <v-icon>mdi-file-eye</v-icon>
                                                                            <v-tooltip activator="parent"
                                                                                location="top">Visualizar</v-tooltip>
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </v-table>
                                                    </v-row>
                                                </v-container>
                                            </v-form>
                                    </v-window-item>
                                    <!--Docs-->
                                     <!--consultas-->
                                    <v-window-item value="consulta">
                                        <div style="padding-top: 20px;padding-bottom: 10px;padding-left: 20px;">
                                            Consultas feitas no cadastro do cliente </div>
                                        <v-form>
                                            <v-container>
                                                <v-row>
                                                    <v-table>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left">
                                                                    Nome
                                                                </th>
                                                                <th class="text-left">
                                                                    Tipo
                                                                </th>
                                                                <th class="text-left">
                                                                    Cadastro
                                                                </th>
                                                                <th class="text-left">
                                                                    Score
                                                                </th>
                                                                <th class="text-left">
                                                                    Visualizações
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="item in ListaConsultas" :key="item.ccsId">
                                                                <td>{{ item.cliNome }}</td>
                                                                <td>{{ item.cliTipo }}</td>
                                                                <td>{{ formattedDate(item.ccsDataConsulta) }}</td>
                                                                <td>{{ item.ccsScore }}</td>
                                                                <td>
                                                                    <button type="button" class="btn btn-info"
                                                                        @click="CarregaModalSerasa(item)"
                                                                        style="color:#ffffff;margin:5px;padding:10px;">
                                                                        Crédito
                                                                    </button>
                                                                    <button type="button" class="btn btn-info"
                                                                        @click="CarregaModalJus(item)"
                                                                        style="color:#ffffff;margin:5px;padding:10px;">
                                                                        Jurídica
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </v-table>
                                                </v-row>
                                            </v-container>
                                        </v-form>

                                    </v-window-item>
                                    <!--consultas-->
                                </v-window>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <!--modal Cliente-->
    <v-row justify="center">
        <v-dialog v-model="dialogCliente" class="controlcelEnd gp-contract-detail-dialog" transition="dialog-bottom-transition"
          width="auto">
            <v-card>
                <v-card-title style="background-color: #cccccc;">
                <span class="text-h5" style="font-size: 19px !important;" >Informações do Cliente</span>
                </v-card-title>
                <v-card-text style="padding: 16px 0px 10px">
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col v-if="Cliente!=''"  cols="12" md="6" style="border-right: 1px solid #cccccc;">
                                    <v-row> 
                                        <v-col cols="12" md="3">
                                            <span style="font-weight: 500;">Nome: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                            <span>{{ Cliente.cliNomeEmpresa }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">CPF/CNPJ: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliDocumento  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3" v-if="Cliente.tpdId == 2">
                                             <span style="font-weight: 500;">Razão Social: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;" v-if="Cliente.tpdId == 2">
                                             <span>{{ Cliente.cliRazaoSocial  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3" v-if="Cliente.tpdId == 2">
                                             <span style="font-weight: 500;">Responsável: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;" v-if="Cliente.tpdId == 2">
                                             <span>{{ Cliente.cliResponsavel  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3" v-if="Cliente.tpdId == 2">
                                             <span style="font-weight: 500;">CPF: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;" v-if="Cliente.tpdId == 2">
                                             <span>{{ Cliente.cliCampoExtra1  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <span style="font-weight: 500;">Telefone: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliTelefone }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Whatsapp: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliWhatsapp }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">E-mail: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliEmail }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Nascimento: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ formattedDate(Cliente.cliDataNascimento) }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Estado Civil: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliEstadoCivil }}</span>
                                        </v-col>
                                       
                                    </v-row>
                                </v-col>
                                <v-col v-if="Endereco!=''"  cols="12" md="6">
                                    <v-row>
                                        <v-col cols="12" md="12">
                                            <span style="font-weight: 500;">Endereço Alternativo: </span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Endereço: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Endereco.cleEndereco }} - {{ Endereco.cleNumero }} - {{  Endereco.cleComplemento }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Cidade/UF: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Endereco.cleCidade }} / {{ Endereco.cleEstado }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Bairro: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Endereco.cleBairro }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">CEP: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Endereco.cleCep }}</span>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col v-if="Cliente!='' && Cliente!=null && Cliente.cliCpfConjuge &&  Cliente.cliCpfConjuge != '' && Cliente.cliCpfConjuge != null"  cols="12" md="6" style="border-right: 1px solid #cccccc;">
                                    <v-row> 
                                        <v-col cols="12" md="3">
                                            <span style="font-weight: 500;">Conjuge: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                            <span>{{ Cliente.cliNomeConjuge }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">CPF: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliCpfConjuge  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <span style="font-weight: 500;">Telefone: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliTelefoneConjuge }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Whatsapp: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliWhatsappConjuge }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">E-mail: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliEmailConjuge }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Data Nascimento: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ formattedDate(Cliente.cliDataNascimentoConjuge)}}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Endereço: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span v-html="Cliente.cliTexto1"></span>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col v-if="Cliente!='' && Cliente!=null && Cliente.cliCpfCorresponsavel &&  Cliente.cliCpfCorresponsavel != '' && Cliente.cliCpfCorresponsavel != null"  cols="12" md="6" style="border-right: 1px solid #cccccc;">
                                    <v-row> 
                                        <v-col cols="12" md="3">
                                            <span style="font-weight: 500;">Corresponsável: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                            <span>{{ Cliente.cliNomeCorresponsavel }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">CPF: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliCpfCorresponsavel  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <span style="font-weight: 500;">Telefone: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliTelefoneCorresponsavel }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Whatsapp: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliWhatsappCorresponsavel }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">E-mail: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliEmailCorresponsavel }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Data Nascimento: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ formattedDate(Cliente.cliDataNascimentoCorresponsavel)}}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Estado Civil: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliEstadoCivilCorresponsavel }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Nome Pai: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliNomePaiCorresponsavel }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Nome Mãe: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliNomeMaeCorresponsavel }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Endereço: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span v-html="Cliente.cliTexto2"></span>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                     <v-btn @click.prevent="dialogCliente=false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>

     <!--modal imobiliaria-->
     <v-row justify="center">
        <v-dialog v-model="dialogImobiliaria" class="controlcelEnd gp-contract-detail-dialog" transition="dialog-bottom-transition"
          width="auto">
            <v-card>
                <v-card-title style="background-color: #cccccc;">
                <span class="text-h5" style="font-size: 19px !important;">Informações do Imobiliária</span>
                </v-card-title>
                <v-card-text style="padding: 16px 0px 10px">
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col v-if="Imobiliaria!=''" cols="12" md="6" style="border-right: 1px solid #cccccc;">
                                    <v-row>
                                        <v-col cols="12" md="3">
                                            <span style="font-weight: 500;">Nome: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                            <span>{{ Imobiliaria.imoNomeEmpresa }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">CPF/CNPJ: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Imobiliaria.imoDocumento  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3"  v-if="Imobiliaria.tpdId == 2">
                                             <span style="font-weight: 500;">Razão Social: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;" v-if="Imobiliaria.tpdId == 2">
                                             <span>{{ Imobiliaria.imoRazaoSocial  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3"  v-if="Imobiliaria.tpdId == 2">
                                             <span style="font-weight: 500;">Responsável: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;" v-if="Imobiliaria.tpdId == 2">
                                             <span>{{ Imobiliaria.imoResponsavel  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3"  v-if="Imobiliaria.tpdId == 2">
                                             <span style="font-weight: 500;">CPF: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;" v-if="Imobiliaria.tpdId == 2">
                                             <span>{{ Imobiliaria.imoCampoExtra1  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <span style="font-weight: 500;">Telefone: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Imobiliaria.imoTelefone }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Whatsapp: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Imobiliaria.imoWhatsapp }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">E-mail: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Imobiliaria.imoEmail }}</span>
                                        </v-col>
                                       
                                    </v-row>
                                </v-col>
                                <v-col v-if="EnderecoImob!=''" cols="12" md="6">
                                    <v-row>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Endereço: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ EnderecoImob.imeEndereco }} - {{ EnderecoImob.imeNumero }} - {{  EnderecoImob.imeComplemento }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Cidade/UF: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ EnderecoImob.imeCidade }} / {{ EnderecoImob.imeEstado }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Bairro: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ EnderecoImob.imeBairro }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">CEP: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ EnderecoImob.imeCep }}</span>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                     <v-btn @click.prevent="dialogImobiliaria=false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>

        <v-row justify="center">
            <v-dialog v-model="dialogSerasa" class="controlcelEnd gp-contract-detail-dialog" transition="dialog-bottom-transition" width="auto">
                <v-card ref="serasaContent">
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Análise de Crédito</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px" v-if="ListaSerasa != '' && ListaSerasa != null && ListaSerasa.reports && ListaSerasa.reports.length > 0">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12" style="border-right: 1px solid #cccccc;">
                                       <v-row v-if="ListaSerasa.reports[0].reportName == 'RELATORIO_BASICO_PF_PME'">
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].reportName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.score }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Probabilidade de Inadimplência: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.defaultRate }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.statusRegistration
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.consumerName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Nome da mãe: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.motherName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ formattedDate(ListaSerasa.reports[0].registration.birthDate)
                                                    }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else-if="ListaSerasa.reports[0].reportName == 'RELATORIO_BASICO_PJ_PME'">
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].reportName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.score }}</span>
                                                <span>{{ ListaSerasa.reports[0].score.message }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Probabilidade de Inadimplência: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ (ListaSerasa.reports[0].score.defaultRate / 100) }} %</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.statusRegistration
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Documento:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.companyDocument }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.companyName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Fundação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    formattedDate(ListaSerasa.reports[0].registration.foundationDate)
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cidade: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.address.city }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Estado: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.address.state }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else-if="ListaSerasa.reports[0].reportName == 'RELATORIO_AVANCADO_TOP_SCORE_PF_PME'">
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].reportName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.score }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Probabilidade de Inadimplência: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.defaultRate }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.statusRegistration
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.consumerName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Nome da mãe: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.motherName }}</span>
                                            </v-col>
                                               <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Estado Civil: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.maritalStatusDescription }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ formattedDate(ListaSerasa.reports[0].registration.birthDate)
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Ocupação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.occupation
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].addresses }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;" v-if="ListaSerasa.reports[0].phones && ListaSerasa.reports[0].phones.length > 0">
                                                <span style="font-weight: 500;">Fone 1: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;" v-if="ListaSerasa.reports[0].phones && ListaSerasa.reports[0].phones.length > 0">
                                                <span>{{ ListaSerasa.reports[0].phones[0] }}</span>
                                            </v-col>
                                             <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;" v-if="ListaSerasa.reports[0].phones && ListaSerasa.reports[0].phones.length > 1">
                                                <span style="font-weight: 500;">Fone 2: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;" v-if="ListaSerasa.reports[0].phones && ListaSerasa.reports[0].phones.length > 1">
                                                <span>{{ ListaSerasa.reports[0].phones[1] }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else-if="ListaSerasa.reports[0].reportName == 'RELATORIO_AVANCADO_PJ_PME'">
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].reportName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.score }}</span>
                                                <span>{{ ListaSerasa.reports[0].score.message }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Probabilidade de Inadimplência: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ (ListaSerasa.reports[0].score.defaultRate / 100) }} %</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.statusRegistration
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Documento:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.documentNumber }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.companyName }}</span>
                                            </v-col>
                                             <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Fantasia:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.companyAlias }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Fundação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    formattedDate(ListaSerasa.reports[0].identificationReport.companyFoundation)
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Funcionários: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    ListaSerasa.reports[0].identificationReport.numberEmployees
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Tributação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    ListaSerasa.reports[0].identificationReport.taxOption
                                                    }}</span>
                                            </v-col>
                                             <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Atividade Econômica: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    ListaSerasa.reports[0].identificationReport.economicActivity
                                                    }}</span>
                                            </v-col>
                                              <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cnae: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    ListaSerasa.reports[0].identificationReport.cnae
                                                    }}</span>
                                            </v-col>
                                           <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;" v-if="ListaSerasa.reports[0].identificationReport">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;" v-if="ListaSerasa.reports[0].identificationReport">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.addresses }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;" v-if="ListaSerasa.reports[0].identificationReport.phone">
                                                <span style="font-weight: 500;">Fone: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;" v-if="ListaSerasa.reports[0].identificationReport.phone">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.phone }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.pefin &&
                                            ListaSerasa.reports[0].negativeData.pefin.pefinResponse &&
                                            ListaSerasa.reports[0].negativeData.pefin.pefinResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras (PEFIN)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(pefin, index) in ListaSerasa.reports[0].negativeData.pefin.pefinResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(pefin.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do contrato:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.contractId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do credor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.creditorName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(pefin.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras (PEFIN)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.refin != '' &&
                                            ListaSerasa.reports[0].negativeData.refin.refinResponse &&
                                            ListaSerasa.reports[0].negativeData.refin.refinResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Restrições Financeiras (REFIN)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(refin, index) in ListaSerasa.reports[0].negativeData.refin.refinResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(refin.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do contrato:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.contractId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do credor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.creditorName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3">
                                                        <span style="font-weight: 500;">Valor da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(refin.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Restrições Financeiras (REFIN)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.notary &&
                                            ListaSerasa.reports[0].negativeData.notary.notaryResponse &&
                                            ListaSerasa.reports[0].negativeData.notary.notaryResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas – Protestos
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(prot, index) in ListaSerasa.reports[0].negativeData.notary.notaryResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(prot.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(prot.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Número do Cartório: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.officeNumber }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cartório: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.officeName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas – Protestos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.check &&
                                            ListaSerasa.reports[0].negativeData.check.checkResponse &&
                                            ListaSerasa.reports[0].negativeData.check.checkResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Cheques Sem Fundo (CCF)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(cheq, index) in ListaSerasa.reports[0].negativeData.check.checkResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(cheq.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do banco: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.bankId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do banco: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.bankName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Número da agência: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.bankAgencyId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Quantidade de cheques: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.checkCount }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Cheques Sem Fundo (CCF)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaSerasa.reports[0].negativeData &&
                                                ListaSerasa.reports[0].negativeData.collectionRecords &&
                                                ListaSerasa.reports[0].negativeData.collectionRecords.collectionRecordsResponse &&
                                                ListaSerasa.reports[0].negativeData.collectionRecords.collectionRecordsResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Dívidas Vencidas (Convem)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].negativeData.collectionRecords.collectionRecordsResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do contrato:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.contractId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do credor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.creditorName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(convem.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Dívidas Vencidas (Convem)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                          <v-row
                                            v-if="ListaSerasa.reports[0].facts &&
                                                ListaSerasa.reports[0].facts.inquiry &&
                                                ListaSerasa.reports[0].facts.inquiry.inquiryResponse &&
                                                ListaSerasa.reports[0].facts.inquiry.inquiryResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Histórico de Consultas de crédito
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].facts.inquiry.inquiryResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Segmento: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.segmentDescription }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Quantidade:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.daysQuantity }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                 Histórico de Consultas de crédito
                                                 {{ ListaSerasa.reports[0].facts ? 'Existe' : 'Não existe' }}
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaSerasa.reports[0].facts &&
                                                ListaSerasa.reports[0].facts.judgementFilings &&
                                                ListaSerasa.reports[0].facts.judgementFilings.judgementFilingsResponse &&
                                                ListaSerasa.reports[0].facts.judgementFilings.judgementFilingsResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Processos em Julgamento
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].facts.judgementFilings.judgementFilingsResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                 <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(convem.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">UF:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.state }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                 Processos em Julgamento
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaSerasa.reports[0].facts &&
                                                ListaSerasa.reports[0].facts.bankrupts &&
                                                ListaSerasa.reports[0].facts.bankrupts.bankruptsResponse &&
                                                ListaSerasa.reports[0].facts.bankrupts.bankruptsResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                               Falências Bancárias
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].facts.bankrupts.bankruptsResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                 <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyName }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                 Falências Bancárias
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaSerasa.reports[0].partner &&
                                                ListaSerasa.reports[0].partner.partnershipResponse &&
                                                ListaSerasa.reports[0].partner.partnershipResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                               Sociedades
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].partner.partnershipResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyName }}</span>
                                                    </v-col>
                                                </v-row>
                                                 <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Participação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.participationPercentage }}</span>
                                                    </v-col>
                                                </v-row>
                                                  <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">UF: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyState }}</span>
                                                    </v-col>
                                                </v-row>
                                                  <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Status: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyStatus }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                  Sociedades
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].reportName == 'RELATORIO_BASICO_PJ_PME' &&
                                            ListaSerasa.reports[0].director &&
                                            ListaSerasa.reports[0].director.DirectorResponse &&
                                            ListaSerasa.reports[0].director.DirectorResponse.results.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Administradores
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(dire, index) in ListaSerasa.reports[0].director.DirectorResponse.results"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Tipo Documento: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.documentType }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Documento: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.documentId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.name }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cargo: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.role }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Possui restrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.hasNegative ? "Sim" : "Não" }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                         <v-btn @click.prevent="exportPdf">Exportar PDF</v-btn>
                        <v-btn @click.prevent="dialogSerasa = false">Fechar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

      <!--modal JusBrasil-->
      <v-row justify="center">
        <v-dialog v-model="dialogJusBrasil" class="controlcelEnd gp-contract-detail-dialog" transition="dialog-bottom-transition"
          width="auto">
            <v-card ref="jusContent">
                <v-card-title style="background-color: #cccccc;">
                <span class="text-h5" style="font-size: 19px !important;">Informações Jurídicas</span>
                </v-card-title>
                <v-card-text style="padding: 16px 0px 10px" v-if="ListaJusBrasil != '' && ListaJusBrasil != null">
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col  cols="12" md="12" style="border-right: 1px solid #cccccc;" v-if="ListaJusBrasil.processos && 
                                                 ListaJusBrasil.processos.length > 0">
                                    <v-row>
                                        <v-col cols="12" md="12">
                                           Dados Cadastrais
                                        </v-col>
                                        <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                            <span style="font-weight: 500;">Nome: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                            <span>{{ ListaJusBrasil.nome }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                            <span style="font-weight: 500;">Tipo: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                            <span>{{ ListaJusBrasil.identificacao.tipo }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                            <span style="font-weight: 500;">Documento: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                            <span>{{ ListaJusBrasil.identificacao.valor }}</span>
                                        </v-col>                        
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;" >
                                            Processos
                                        </v-col>
                                        <v-col cols="12" md="12" v-for="(proc,index) in ListaJusBrasil.processos" :key="index" :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'" >
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Tipo Processo: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.tipo_processo }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Data Atualização: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.data_ultima_atualizacao }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Natureza: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.natureza }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row v-if="proc.partes.length > 0">
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Partes: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9" style="text-align: left; padding-bottom: 2px; padding-top: 3px;">
                                                        <div v-for="(parte, indexParte) in proc.partes" :key="indexParte">
                                                            <span><strong>Nome:</strong> {{ parte.nome }}</span><br>
                                                            <span><strong>Papel:</strong> {{ parte.papel }}</span>
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Assunto: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.assunto }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Ano Processo: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.ano_do_processo }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Tribunal: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.tribunal }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">UF: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.UF }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Comarca: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.comarca }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Fórum: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.forum }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Valor da causa: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ formatarValor(proc.valor_causa) }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Numero Processo: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.numero_processo }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Link: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.link }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Status: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.status }}</span>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col v-else>
                                    <v-col v-if="ListaJusBrasil.fault" cols="12" md="12" style="background-color: #cccccc;margin-top:30px;" >
                                        {{ ListaJusBrasil.fault.faultstring }}
                                    </v-col>
                                    <v-col v-else cols="12" md="12" style="background-color: #cccccc;margin-top:30px;" >
                                        Nada Consta
                                    </v-col>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                     <v-btn @click.prevent="export2Pdf">Exportar PDF</v-btn>
                     <v-btn @click.prevent="dialogJusBrasil=false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
         <!--modal CDL 2-->
         <v-row justify="center">
            <v-dialog v-model="dialogSerasa2" class="controlcelEnd gp-contract-detail-dialog" transition="dialog-bottom-transition" width="auto" >
                <v-card ref="serasaContent">
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Análise de Crédito</span>
                        <span class="text-h5" style="font-size: 19px !important;" v-if="ConsultasCliente.filter(x=> x.tipo == 'cdl').length > 0"> - Data: {{ formattedDate(ConsultasCliente.filter(x=> x.tipo == 'cdl')[0].dtRetorno) }}</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px">
                        <v-form>
                            <v-container>
                                <v-row v-if="Cliente.tpdId == 1 && ListaCdl != '' && ListaCdl != null && ListaCdl.ConsultaFamiliaPositivoResponse && ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult && ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo">
                                    <v-col cols="12" md="12" style="border-right: 1px solid #cccccc;">
                                        <v-row>
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>Consulta Familia Positivo</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.score_classificacao_varios_modelos[0].score }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Status Consumidor: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.status_consumidor.mensagem }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.identificacao.documento }}</span>
                                            </v-col>
                                             <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Título eleitor: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.identificacao.tituloEleitor }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.identificacao.nome }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Nome da mãe: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.identificacao.nomeMae }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.identificacao.dataNascimento }}</span>
                                            </v-col>
                                             <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Obito: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.identificacao.obito }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3"
                                                style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Decisão Sugerida: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.decisao.texto }}</span>
                                            </v-col>

                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo &&
                                                     Array.isArray(ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.debitos) &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.debitos.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(pefin, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.debitos"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data Ocorrência: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.dataOcorrencia }}</span>
                                                    </v-col>
                                                </v-row>
                                                 <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data Disponibilização: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.dataDisponibilizacao }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do contrato:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.contrato }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do credor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.informante }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.moeda }} {{ pefin.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                                   <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Segmento: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.segmento }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.uf }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo &&
                                                     Array.isArray(ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.titulos_protestados) &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.titulos_protestados.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas – Protestos
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(prot, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.titulos_protestados"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.dataOcorrencia }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.moeda }} {{ prot.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Número do Cartório: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.cartorio }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.cidade }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.uf }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas – Protestos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo &&
                                                     Array.isArray(ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.relacao_consultas_anteriores_credito_segmento) &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.relacao_consultas_anteriores_credito_segmento.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Histórico de Consultas de crédito
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.relacao_consultas_anteriores_credito_segmento"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.data }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.informante }}</span>
                                                    </v-col>
                                                </v-row>
                                             </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Histórico de Consultas de crédito
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo &&
                                                     Array.isArray(ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.informacoes_complementares) &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.informacoes_complementares.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Ações Judiciais
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.informacoes_complementares"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Informação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.texto }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">UF:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.ufOrigem }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Ações Judiciais
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo &&
                                                     Array.isArray(ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.relacao_falencia_recuperacao_judicial) &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.relacao_falencia_recuperacao_judicial.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Falências Bancárias
                                            </v-col>
                                            {{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.relacao_falencia_recuperacao_judicial }}
                                            <!--v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].facts.bankrupts.bankruptsResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyName }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col-->
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Falências Bancárias
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.participacoes_do_documento_consultado">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Sociedades
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.participacoes_do_documento_consultado.razaoSocial }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Participação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.participacoes_do_documento_consultado.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">CNPJ: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.participacoes_do_documento_consultado.numeroDocumentoA }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Função: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.participacoes_do_documento_consultado.funcao }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Sociedades
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row v-else-if="Cliente.tpdId == 2 && ListaCdl != null && ListaCdl.ConsultaDefineLimitePositivoResponse && ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult && ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo">
                                       <v-col cols="12" md="12" style="border-right: 1px solid #cccccc;">
                                        <v-row>
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>Consulta Define Limite Positivo</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.score.score_pj.score }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Status Consumidor: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.score.score_pj.texto }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.cnpj }}</span>
                                            </v-col>
                                             <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Razão Social: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.razao_social }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Fantasia:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.nome_fantasia }}</span>
                                            </v-col>
                                               <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação CNPJ: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.situacao_cnpj }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Natureza Juridica: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.natureza_juridica }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Data Fundação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.data_fundacao }}</span>
                                            </v-col>
                                             <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Segmento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.segmento }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3"
                                                style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Decisão Sugerida: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.decisao.descricao }}</span>
                                            </v-col>

                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.pendencias_restricoes != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                  {{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.pendencias_restricoes }}
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                         <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.protestos != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Protestos
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                  {{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.protestos }}
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Protestos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.cheques_sem_fundo != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Cheques sem fundos
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                  {{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.cheques_sem_fundo }}
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Cheques sem fundos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.cheques_sustados != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Cheques sustados
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                  {{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.cheques_sustados }}
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Cheques sustados
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.acoes_civeis != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Ações Civeis
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                  {{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.acoes_civeis }}
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Ações Civeis
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     Array.isArray(ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.consultas.ultimas_consultas) &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.consultas.ultimas_consultas > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Histórico de Consultas de crédito
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.consultas.ultimas_consultas"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.data) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.razao_social }}</span>
                                                    </v-col>
                                                </v-row>
                                             </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Histórico de Consultas de crédito
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.falencias_recuperacao_judicial != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Falências Bancárias
                                            </v-col>
                                              <v-col cols="12" md="12">
                                                 {{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.falencias_recuperacao_judicial }}
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Falências Bancárias
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click.prevent="exportPdf">Exportar PDF</v-btn>
                        <v-btn @click.prevent="dialogSerasa2 = false">Fechar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>


        <!--modal Cdl-->
         <v-row justify="center">
            <v-dialog v-model="dialogCdl" class="controlcelEnd gp-contract-detail-dialog" transition="dialog-bottom-transition" width="auto" >
                <v-card ref="serasaContent">
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Análise Crédito</span>
                        <span class="text-h5" style="font-size: 19px !important;" v-if="ConsultasCliente.filter(x=> x.tipo == 'cdl').length > 0"> - Data: {{ formattedDate(ConsultasCliente.filter(x=> x.tipo == 'cdl')[0].dtRetorno) }}</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12" v-if="Cliente.tpdId == 1 && ListaCdl != '' && ListaCdl != null && ListaCdl.ConsultaFamiliaPositivoResponse && ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult && ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo"
                                       style="border-right: 1px solid #cccccc;">
                                           <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.score_classificacao_varios_modelos.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Classificação Score
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(pefin, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.score_classificacao_varios_modelos"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Decrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.descricaoNatureza }}</span>
                                                    </v-col>
                                                </v-row>
                                                 <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Score: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.score }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Texto: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.texto }}</span>
                                                    </v-col>
                                                </v-row>
                                                  <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Texto Complementar: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.texto2 }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Classificação Score
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>

                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Pontualidade Parcelamentos
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento.nota_pontualidade.operacoes_parceladas.item_painel_controle"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Descrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.descricao }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Pontualidade Parcelamentos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>

                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Pontualidade Cartão Crédito
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento.nota_pontualidade.cartao_credito.item_painel_controle"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Descrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.descricao }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Pontualidade Cartão Crédito
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>

                                           <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo &&
                                                        ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nota Atraso Fatura: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento.nota_comportamento_fatura_em_atraso.nota }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nota Adiantamento Fatura: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento.nota_comportamento_adiantamento_de_pagamento.nota }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_consumo">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Consumo - Comprometimento Parcelemantos
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_consumo.pontuacao_comprometimento.operacoes_parceladas.item_painel_controle"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Descrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.descricao }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                               Comportamento Consumo - Comprometimento Parcelemantos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_consumo">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Consumo - Comprometimento Cartão Crédito e Cheque Especial
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_consumo.pontuacao_comprometimento.cartao_credito_cheque_especial_e_outros_rotativos.item_painel_controle"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Descrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.descricao }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                               Comportamento Consumo - Comprometimento Cartão Crédito e Cheque Especial
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo &&
                                        ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_consumo">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento contratos recentes
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nota contratos recentes: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_consumo.nota_comportamento_contratos_recentes.nota }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" md="12" v-else-if="Cliente.tpdId == 2 && ListaCdl != null && ListaCdl.ConsultaDefineLimitePositivoResponse && ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult && ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo"
                                       style="border-right: 1px solid #cccccc;">
                                           <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.score.score_pj != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Classificação Score
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Decrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.score.score_pj.texto }}</span>
                                                    </v-col>
                                                </v-row>
                                                 <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Score: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.score.score_pj.score }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Faturamento Presumido: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.faturamento_presumido.faturamento_anual }}</span>
                                                    </v-col>
                                                </v-row>
                                                  <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Texto Complementar: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.faturamento_presumido.mensagem }}</span>
                                                    </v-col>
                                                </v-row>
                                                  <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Limite de Crédito: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.limite_credito.score }}</span>
                                                    </v-col>
                                                </v-row>
                                                 <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Texto Complementar: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.limite_credito.texto }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Classificação Score
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>

                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.pagamento_pontual.lista_indicador_comportamento.item_indicador.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Pontualidade
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.pagamento_pontual.lista_indicador_comportamento.item_indicador"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Mês: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.mes_ano }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Pontuação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.pontuacao_mensal }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Pontualidade
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.pagamento_atrasado.periodo_6_a_15_dias.lista_indicador_comportamento.item_indicador.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Atrasados
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.pagamento_atrasado.periodo_6_a_15_dias.lista_indicador_comportamento.item_indicador"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Mês: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.mes_ano }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Pontuação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.pontuacao_mensal }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                               Comportamento Pagamento - Atrasados
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                          
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.comprometimento_futuro.lista_credito.credito.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comprometimento Futuro
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.comprometimento_futuro.lista_credito.credito"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Período: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.periodo }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Pontuação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.pontuacao }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                               Comprometimento Futuro
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click.prevent="exportPdf">Exportar PDF</v-btn>
                        <v-btn @click.prevent="dialogCdl = false">Fechar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import moment from 'moment'
import { useRoute } from 'vue-router';
import VueSpeedometer from "vue-speedometer";

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';


export default {
    name: 'ContratacaoVigenciaFinalizadaDetalheView',
    components: {
        EasyDataTable,
        moment,
        VueSpeedometer
    },
    setup() {
        const route = useRoute();
        const id = route.params.idPed;

        return {
            id,
        };
    },
    data: () => ({
         User: {
            garid:0,
            tpeid:0,
            pesid:0,
            cusid:0
        },
        tab: null,
        secaoFinalizada: 'analise',
        NomeTela: 'Contratações',
        InfoTela: 'Detalhe Contratação',
        MostraGrid: true,
        Cliente: [],
        Imobiliaria: [],
        PlanosGarantias:[],
        headers: [],
        Idiomas: [],
        vshowidioma: true,
        CadastroTelas: [{ cdtId: 28, cdtNome: "Detalhe Contratação" }],
        PedidosCli: [],
        Pedidos: [],
        TotalPedido: 0,
        validacomprova: [],
        PedidosComprova: [],
        showModal_comprova: false,
        ListaPedidoItem: [],
        ListaPedidoItemAdicional: [],
        PedidosMensagem: [],
        PedidosAgendamento: [],
        PedidosEndereco: [],
        PedidosComprova:[],  
        Estados: [],
        Cidades: [],
        Bairros: [],
        selectedFile: '',
        urlComprovante: '',
        PedidoComprovante: [],
        Situacoes: [],
        dialogCliente:false,
        dialogImobiliaria:false,
        ListEndereco:[],
        EnderecoImob:{},
        ListEnderecoImob:[],
        Endereco:{},
        ValidaCustomer:{},
        DadosGarantidora:[],
         //Documentos
         ListDocumentos:[],
        Documentos: {
            cdoId:0,
            cdoDocumento:'', 
            cdoNomeDocumento:'', 
            cdoUrlDocumento:'',
            cliId:'',
        },
        DocSelected:null,
        ListaDocs:[],
        TiposDocumentos:[],
        ListEntidadesDocumentos:[],
        selectedFile: '',
        //serasa
        score: 0,
        dialogSerasa:false,
        dialogSerasa2:false,
        dialogCdl:false,
        ListaSerasa: null,
        ListaJusBrasil: null,
        ListaSerasa2: null,
        ListaJusBrasil2: null,
        ListaCdl:null,
        ListaInvoice: null,
        ListaProdutosImg:[],
        dialogJusBrasil: false,
        nomeDocumento:'',
        ContratoPedido:[],
        Assinatura:[],
        ListaContratos:[],
        ListDocumentosAssinado:[],
        ListDocumentosAss:null,
        //docs
        ListaDocs: [],
        //consultas
        ListaConsultas: [],
        ConsultasCliente: [],
        ConsultasConjuge: [],
        ConsultasCorresp1: [],
        ConsultasCorresp2: [],
    }),
    methods: {
        AbrirSecaoFinalizada(secao) {
            this.secaoFinalizada = secao;
        },
        CoberturaProduto(produto) {
            let dados = Array.isArray(this.ListDocumentosAss) ? this.ListDocumentosAss[0]?.pftDadosContrato : null;
            for (let tentativa = 0; tentativa < 3 && typeof dados === 'string'; tentativa += 1) {
                try { dados = JSON.parse(dados); } catch { dados = null; break; }
            }
            const multiplicador = dados?.multiplicador ?? dados?.Multiplicador;
            if (multiplicador) return String(multiplicador);
            return produto?.pdiCampoExtraCobertura || '—';
        },
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else {
                return "";
            }

        },
        formatarValor(valor) {
            // Verifica se o valor é inteiro
            if (Number.isInteger(valor)) {
                return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
            // Formata normalmente para valores com casas decimais
            return parseFloat(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        formatarTaxa(valor) {
            if (valor === null || valor === undefined || String(valor).trim() === '') return '—';
            const numero = Number(String(valor).replace('%', '').replace(',', '.').trim());
            if (!Number.isFinite(numero)) return '—';
            const percentual = Math.abs(numero) <= 1 ? numero * 100 : numero;
            return `${percentual.toLocaleString('pt-BR', { maximumFractionDigits: 4 })}%`;
        },
        async UploadImg(value) {
            const formData = new FormData();
            formData.append('file', value);
            const uploadResult = await axios.post(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/upload`, formData);
            return uploadResult;
        },
        buildFileUrl(path) {
            if (!path) return '';
            const rel  = String(path).replace(/\\/g, '/'); // normaliza separadores
            const base = this.$imgURL;
            return `${base}/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetFileByParam?param=${encodeURIComponent(rel)}&t=${Date.now()}`;
        },
        openInNewTab(path) {
            const url = this.buildFileUrl(path);
            if (!url) return;
            window.open(url, '_blank', 'noopener,noreferrer'); // nova aba
        },
        calculatotal() {
            var valorProdutos = 0;

            if (this.ListaPedidoItem != '') {
                this.ListaPedidoItem.forEach(item => {
                    valorProdutos += item.pdiValorTotalProduto;
                });
            }

            this.TotalPedido = (valorProdutos);
        },
        async openDialogCliente(value){
         //carrega endereco
         await axios.get(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetEnderecoByCli/`+ value)
                        .then(response => {
                            this.ListEndereco = response.data;                             
                            if (this.ListEndereco != ''){
                                this.Endereco = this.ListEndereco[0];
                                this.dialogCliente = true;
                                //console.log('this.Endereco')
                                //console.log(this.Endereco)
                            }            
                        });
        },
        async openDialogImobiliaria(value){
         //carrega endereco
         await axios.get(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetByImoIdEndereco/`+ value)
                        .then(response => {
                            this.ListEnderecoImob = response.data;                             
                            if (this.ListEnderecoImob != ''){
                                this.EnderecoImob = this.ListEnderecoImob[0];
                                this.dialogImobiliaria = true;
                                //console.log('this.EnderecoImob')
                                //console.log(this.EnderecoImob)
                            }            
                        });
        },
        async EnviarDocumento(){
            if (this.nomeDocumento == '' || this.nomeDocumento == null) {
                this.$mensagemAviso("Preencha nome do documento a ser enviado.")
            }
            else if (this.selectedFile == '' || this.selectedFile == null){
                this.$mensagemAviso("Selecione um Documento a ser enviado.")
            }
            else{
                if (this.selectedFile != '' && this.selectedFile != null) {
                    const uploadSuccess = await this.UploadImg(this.selectedFile[0]);
                    if (uploadSuccess.status == 200) {
                        let _pedidoMensagem = {
                            PmsId: 0,
                            GrtId: 0,
                            CdtId: 0,
                            PmsUrlImagem: uploadSuccess.data.nameFile,
                            PmsNome: this.nomeDocumento,
                            PmsTipo: "",
                            PmsTexto: "", 
                            PmsCampoExtra1: "",
                            PedId: this.PedidosCli.pedId,
                         };
 
                         await axios.post(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/AddDocAnaliseHist`, _pedidoMensagem)
                            .then((response) => {
                            if (response.data > 0) {
                                axios.get('/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetAllByPedIdDocAnaliseHist/' + this.PedidosCli.pedId)
                                    .then(response => {
                                        this.ListDocumentos = response.data;
                                        let _pmsdel = this.ListDocumentos.filter(x=> x.pmsNome == this.DocSelected.pmsNome && (x.pmsUrlImagem == '' || x.pmsUrlImagem == null));
                                        if (_pmsdel != ''){
                                            let _pmsId = _pmsdel[0].pmsId
                                                axios.delete(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/DeleteDocAnaliseHist/${_pmsId}`)
                                                        .then(response => {
                                                            if (response.status == 200) {
                                                                //carrega documentos
                                                                axios.get('/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetAllByPedIdDocAnaliseHist/' + this.PedidosCli.pedId)
                                                                .then(response => {
                                                                    this.ListDocumentos = response.data;
                                                                    this.DocSelected = null;
                                                                    this.selectedFile = '';
                                                                })
                                                                .catch(error => {
                                                                    console.error(error);
                                                                });
                                                            }
                                                        });
                                        }
                                        else{
                                            this.DocSelected = null;
                                            this.selectedFile = '';
                                        }
                                       
                                    })
                                    .catch(error => {
                                        console.error(error);
                                    });
                            }
                            });
                    }
                    else {
                        this.$mensagemErro("Não foi possível carregar imagem.")
                    }
              }
         }
        },
        DeleteDocumento(item){
            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.pmsId;
                axios.delete(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/DeleteDocAnaliseHist/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                         //carrega documentos
                         axios.get('/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetAllByPedIdDocAnaliseHist/' + this.PedidosCli.pedId)
                        .then(response => {
                            this.ListDocumentos = response.data;
                        })
                        .catch(error => {
                            console.error(error);
                        });
                    }
                });
            }
            });
        },
        async exportPdf() {
            console.log('🖨️ exportPdf iniciado')
            // 1) Aguarda o Vue terminar de renderizar
            await this.$nextTick()

            // 2) Busca o ref
            let element = this.$refs.serasaContent

            // Se for um componente Vue, pega o elemento real
            if (element && element.$el) {
                element = element.$el
                console.log('🔍 usando element.$el =', element)
            }

            // Verifica se está no documento
            if (!element || !document.body.contains(element)) {
                console.error('❌ Elemento não encontrado ou não anexado ao DOM')
                return
            }

            // 3) Faz o clone off-screen
            const clone = element.cloneNode(true)
            Object.assign(clone.style, {
                position: 'absolute',
                top: '-9999px',
                left: '-9999px',
                width: `${element.offsetWidth}px`,
                maxHeight: 'none',
                overflow: 'visible'
            })
            document.body.appendChild(clone)
            console.log('📋 clone adicionado ao body:', clone)

            try {
                // 4) Renderiza o clone
                console.log('⏳ chamando html2canvas em clone…')
                const canvas = await html2canvas(clone, { scale: 2, useCORS: true })
                console.log('✅ canvas gerado')

                // 5) Remove o clone
                document.body.removeChild(clone)
                console.log('🧹 clone removido')

                // 6) Gera o PDF
                const imgData = canvas.toDataURL('image/png')
                const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' })

                const margin    = 10;   
                const pageW = pdf.internal.pageSize.getWidth()
                const pageH = pdf.internal.pageSize.getHeight()
                const props = pdf.getImageProperties(imgData)
                const imgW = pageW
                const imgH = (props.height * pageW) / props.width

                let posY = margin;
                pdf.addImage(imgData, 'PNG', 0, posY, imgW, imgH)

                while (imgH - Math.abs(posY) > pageH) {
                    posY -= pageH
                    pdf.addPage()
                    pdf.addImage(imgData, 'PNG', 0, posY, imgW, imgH)
                }

                pdf.save('analise_credito.pdf')
                console.log('✅ PDF salvo')
            }
            catch (err) {
                console.error('❌ erro ao gerar PDF:', err)
                // garante remoção do clone
                if (document.body.contains(clone)) {
                    document.body.removeChild(clone)
                }
            }
        },
         async export2Pdf() {
            console.log('🖨️ exportPdf iniciado')
            // 1) Aguarda o Vue terminar de renderizar
            await this.$nextTick()

            // 2) Busca o ref
            let element = this.$refs.jusContent

            // Se for um componente Vue, pega o elemento real
            if (element && element.$el) {
                element = element.$el
                console.log('🔍 usando element.$el =', element)
            }

            // Verifica se está no documento
            if (!element || !document.body.contains(element)) {
                console.error('❌ Elemento não encontrado ou não anexado ao DOM')
                return
            }

            // 3) Faz o clone off-screen
            const clone = element.cloneNode(true)
            Object.assign(clone.style, {
                position: 'absolute',
                top: '-9999px',
                left: '-9999px',
                width: `${element.offsetWidth}px`,
                maxHeight: 'none',
                overflow: 'visible'
            })
            document.body.appendChild(clone)
            console.log('📋 clone adicionado ao body:', clone)

            try {
                // 4) Renderiza o clone
                console.log('⏳ chamando html2canvas em clone…')
                const canvas = await html2canvas(clone, { scale: 2, useCORS: true })
                console.log('✅ canvas gerado')

                // 5) Remove o clone
                document.body.removeChild(clone)
                console.log('🧹 clone removido')

                // 6) Gera o PDF
                const imgData = canvas.toDataURL('image/png')
                const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' })

                const margin    = 10;   
                const pageW = pdf.internal.pageSize.getWidth()
                const pageH = pdf.internal.pageSize.getHeight()
                const props = pdf.getImageProperties(imgData)
                const imgW = pageW
                const imgH = (props.height * pageW) / props.width

                let posY = margin;
                pdf.addImage(imgData, 'PNG', 0, posY, imgW, imgH)

                while (imgH - Math.abs(posY) > pageH) {
                    posY -= pageH
                    pdf.addPage()
                    pdf.addImage(imgData, 'PNG', 0, posY, imgW, imgH)
                }

                pdf.save('analise_juridica.pdf')
                console.log('✅ PDF salvo')
            }
            catch (err) {
                console.error('❌ erro ao gerar PDF:', err)
                // garante remoção do clone
                if (document.body.contains(clone)) {
                    document.body.removeChild(clone)
                }
            }
        },
        CarregaDocs(_cliId) {
            axios.get(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetBycliIdDocs/` + _cliId)
                .then(response => {
                    if (response.data.length > 0) {
                        this.ListaDocs = response.data;
                    }
                    else {
                        this.ListaDocs = [];
                    }
                });
        },
        VisualizarDocumento(item) {
         if (item) {
           this.openInNewTab(item);
          }
        },
        CarregaConsultas(_cliId) {
            axios.get(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetBycliIdConsulta/` + _cliId)
                .then(response => {
                    if (response.data.length > 0) {
                        this.ListaConsultas = response.data;
                    }
                    else {
                        this.ListaConsultas = [];
                    }
                });
        },
        limparDocumento(value) {
            return value ? String(value).replaceAll('.', '').replaceAll('-', '').replaceAll('/','') : '';
        },
        getConsulta(lista, tipo) {
            return Array.isArray(lista) ? lista.find(x => x.tipo == tipo) : null;
        },
        normalizaConsultasCredito(lista) {
            if (!Array.isArray(lista)) {
                return [];
            }

            return lista.map(item => ({
                documento: item.documento ?? item.Documento,
                dtRetorno: item.dtRetorno ?? item.DtRetorno,
                mensagem: item.mensagem ?? item.Mensagem,
                obsAnalise: item.obsAnalise ?? item.ObsAnalise,
                retorno: item.retorno ?? item.Retorno,
                score: item.score ?? item.Score,
                statusRetorno: item.statusRetorno ?? item.StatusRetorno,
                tipo: item.tipo ?? item.Tipo,
            }));
        },
        completaConsultasClienteAvulsas() {
            if (!Array.isArray(this.ListaConsultas) || this.ListaConsultas.length == 0) {
                return;
            }

            if (!Array.isArray(this.ConsultasCliente)) {
                this.ConsultasCliente = [];
            }

            const consulta = this.ListaConsultas.find(x => x.ccsSerasa || x.CcsSerasa || x.ccsJusBrasil || x.CcsJusBrasil || x.ccsJusbrasil || x.CcsJusbrasil);
            const document = this.limparDocumento(this.Cliente.cliDocumento);
            const serasa = consulta?.ccsSerasa ?? consulta?.CcsSerasa;
            const jusBrasil = consulta?.ccsJusBrasil ?? consulta?.CcsJusBrasil ?? consulta?.ccsJusbrasil ?? consulta?.CcsJusbrasil;
            const dataConsulta = consulta?.ccsDataConsulta ?? consulta?.CcsDataConsulta;

            if (serasa && this.ConsultasCliente.filter(x=> x.tipo == 'ser').length == 0) {
                this.ConsultasCliente.push({
                    documento: document,
                    dtRetorno: dataConsulta,
                    mensagem: '',
                    obsAnalise: null,
                    retorno: serasa,
                    score: this.extraiScoreSerasa(serasa),
                    statusRetorno: '200',
                    tipo: 'ser'
                });
            }

            if (jusBrasil && this.ConsultasCliente.filter(x=> x.tipo == 'jus').length == 0) {
                this.ConsultasCliente.push({
                    documento: document,
                    dtRetorno: dataConsulta,
                    mensagem: '',
                    obsAnalise: null,
                    retorno: jusBrasil,
                    score: 0,
                    statusRetorno: '200',
                    tipo: 'jus'
                });
            }
        },
        extraiScoreSerasa(value) {
            try {
                const parsed = JSON.parse(value);
                return parsed?.reports?.[0]?.score?.score ?? 0;
            }
            catch {
                return 0;
            }
        },
        getScoreConsulta(lista) {
            const serasa = this.getConsulta(lista, 'ser');
            if (serasa?.score != null) {
                return serasa.score;
            }

            const cdlScore = this.getCdlScore(lista);
            return cdlScore != null ? cdlScore : 0;
        },
        getObsConsulta(lista, tipo, label) {
            const consulta = this.getConsulta(lista, tipo);
            return consulta?.obsAnalise ? `${label}: ${consulta.obsAnalise}` : null;
        },
        getCdlScore(lista) {
            try {
                const cdl = this.getConsulta(lista, 'cdl');
                if (!cdl?.retorno) {
                    return null;
                }

                const retorno = JSON.parse(cdl.retorno);
                const score = retorno?.ConsultaFamiliaPositivoResponse?.ConsultaFamiliaPositivoResult?.completo?.score_classificacao_varios_modelos;
                return Array.isArray(score) ? score[0]?.score ?? null : score?.score ?? null;
            }
            catch {
                return null;
            }
        },
        isRetornoCpfNotAvailable(item) {
            if (!item?.retorno) {
                return false;
            }

            try {
                const retorno = JSON.parse(item.retorno);
                const mensagem = JSON.stringify(retorno).toUpperCase();
                return mensagem.includes('CPF NAO DISPONIVEL') || mensagem.includes('CPF NÃO DISPONÍVEL');
            }
            catch {
                return String(item.retorno).toUpperCase().includes('CPF NAO DISPONIVEL');
            }
        },
        CarregaConsultasDocumento(_document, target, usarFallbackPedido = false) {
            const document = this.limparDocumento(_document);
            if (!document) {
                this[target] = [];
                return;
            }

            axios.get(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetAllByConsultasCreditoByDocId/` + document)
                .then(response => {
                    this[target] = this.normalizaConsultasCredito(response.data);

                    if (usarFallbackPedido) {
                        this.completaConsultasPedidoAtual(target, document);
                    }

                    if (target == 'ConsultasCliente') {
                        this.completaConsultasClienteAvulsas();
                    }
                })
                .catch(error => {
                    console.error(error);
                    this[target] = [];

                    if (usarFallbackPedido) {
                        this.completaConsultasPedidoAtual(target, document);
                    }

                    if (target == 'ConsultasCliente') {
                        this.completaConsultasClienteAvulsas();
                    }
                });
        },
        completaConsultasPedidoAtual(target, document) {
            if (!Array.isArray(this[target])) {
                this[target] = [];
            }

            if (this[target].filter(x=> x.tipo == 'ser').length == 0 && this.PedidosCli.pedSerasa) {
                this[target].push({
                    documento: document,
                    dtRetorno: this.PedidosCli.pedDataPedido,
                    mensagem: '',
                    obsAnalise: this.PedidosCli.pedObsAnalise,
                    retorno: this.PedidosCli.pedSerasa,
                    score: this.PedidosCli.pedScore,
                    statusRetorno: '200',
                    tipo: 'ser'
                });
            }

            if (this[target].filter(x=> x.tipo == 'jus').length == 0 && this.PedidosCli.pedJusBrasil) {
                this[target].push({
                    documento: document,
                    dtRetorno: this.PedidosCli.pedDataPedido,
                    mensagem: '',
                    obsAnalise: this.PedidosCli.pedObsAnalise,
                    retorno: this.PedidosCli.pedJusBrasil,
                    score: this.PedidosCli.pedScore,
                    statusRetorno: '200',
                    tipo: 'jus'
                });
            }
        },
        CarregaModalSerasaCredito(value) {
            this.ListaSerasa = JSON.parse(value);
            this.dialogSerasa = !this.dialogSerasa;
        },
        normalizeListaCdl(list) {
            if (!list || !list.ConsultaFamiliaPositivoResponse?.ConsultaFamiliaPositivoResult?.completo) {
                return;
            }

            const completo = list.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo;

            [
                'debitos',
                'titulos_protestados',
                'relacao_consultas_anteriores_credito_segmento',
                'informacoes_complementares',
                'relacao_falencia_recuperacao_judicial'
            ].forEach(field => {
                const fieldValue = completo[field];
                if (fieldValue && !Array.isArray(fieldValue) && fieldValue.registro === 'S') {
                    completo[field] = [fieldValue];
                }
            });

            if (completo.score_classificacao_varios_modelos && !Array.isArray(completo.score_classificacao_varios_modelos)) {
                completo.score_classificacao_varios_modelos = [completo.score_classificacao_varios_modelos];
            }
        },
        CarregaModalSerasaCredito2(value) {
            try {
                const parsed = JSON.parse(value);
                this.normalizeListaCdl(parsed);
                this.ListaCdl = parsed;
            }
            catch (error) {
                console.error('Erro ao parsear ListaCdl em CarregaModalSerasaCredito2:', error);
                this.ListaCdl = null;
            }
            this.dialogSerasa2 = !this.dialogSerasa2;
        },
        CarregaModalJusCredito(value) {
            const cleanedJson = value
                .replace(/,\s*}/g, '}')
                .replace(/,\s*]/g, ']');

            this.ListaJusBrasil = JSON.parse(cleanedJson);
            this.dialogJusBrasil = !this.dialogJusBrasil;
        },
        CarregaModalCdlCredito(value) {
            try {
                const parsed = JSON.parse(value);
                this.normalizeListaCdl(parsed);
                this.ListaCdl = parsed;
            }
            catch (error) {
                console.error('Erro ao parsear ListaCdl em CarregaModalCdlCredito:', error);
                this.ListaCdl = null;
            }
            this.dialogCdl = !this.dialogCdl;
        },
        CarregaModalSerasa2(value) {
            this.ListaSerasa = value;
            this.dialogSerasa = !this.dialogSerasa;
        },
         CarregaModalJus2(value) {
            this.ListaJusBrasil = value;
            this.dialogJusBrasil = !this.dialogJusBrasil;
        },
        CarregaModalSerasa(value) {
            this.ListaSerasa = JSON.parse(value.ccsSerasa);
            this.dialogSerasa = !this.dialogSerasa;
        },
        CarregaModalJus(value) {
            const cleanedJson = value.ccsJusBrasil
                .replace(/,\s*}/g, '}')
                .replace(/,\s*]/g, ']');

            const parsedData = JSON.parse(cleanedJson);
            this.ListaJusBrasil = parsedData;
            this.dialogJusBrasil = !this.dialogJusBrasil;
        },
        CancelarVigencia(){
         this.$mensagemConfirma('Ao encerrar esta vigência finalizada, não será possível renová-la. Deseja continuar?')
            .then((result) => {
            if (result.isConfirmed) {
             const data = moment().format('YYYY-MM-DD_HH-mm'); 
             const param2Raw = `Encerramento de vigência finalizada - Usuário: ${this.User.cusid} - Data: ${data}`;
             const param2 = encodeURIComponent(param2Raw);
                const param1 = this.PedidosCli.pedId;
                axios.post(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/EncerramentoContratacaoVigencia/${param1}/${param2}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Vigência encerrada.")
                        this.$router.push('/ListaContratacoesVigenciaFinalizada');
                    }
                });
            }
            });
        },
        //
         async PutSituacao(value) {
            //seguir avisos e proxima etapa
            if (value == 12) {
               /* this.PedidosCli.pspId = value;
                this.PedidosCli.pedSituacaoPedido = 'Aguardando Documentos';
                await axios.put(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/UpdatePedidos`, this.PedidosCli)
                this.$mensagemAviso("Dados Salvos, foi enviado aviso via e-mail para imobiliária.")
                var _texto = "Solicitamos documentação complementar para análise da contratação. ";
                this.EnviaAvisoImobiliariaDocs(_texto);
                this.$router.push('/listacontratacoes');*/
            }
            else if (value == 11) {
                this.PedidosCli.pspId = value;
                this.PedidosCli.pedSituacaoPedido = 'Vigência Renovada';
                await axios.post(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/UpdateRenovarVigencia/` + this.PedidosCli.pedId);
                this.$router.push('/listacontratacoes');
                //this.$mensagemAviso("Dados Salvos, foi enviado aviso via e-mail para imobiliária.")
                //var _texto = "Contratação não foi aprovada. ";
                //this.EnviaAvisoImobiliariaStatus(_texto);

            }
        },
        async Get() {
               await axios.get(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetDadosHist`)
                .then(response => {
                     this.User.garid = response.data.garId;
                      this.User.tpeid = response.data.tpeId;
                      this.User.pesid = response.data.pesId;
                      this.User.cusid = response.data.cusId;
                      if (this.User.tpeid == 3) this.secaoFinalizada = 'observacoes';
                });

            await axios.get(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetByIdPedidosHist/` + this.id)
                .then(response => {
                    this.PedidosCli = response.data;
                     console.log('this.PedidosCli')
                     console.log(this.PedidosCli)
                    if (this.PedidosCli.pedSerasa != '' && this.PedidosCli.pedSerasa != null){
                    this.score = this.PedidosCli.pedScore;
                    this.ListaSerasa2 = JSON.parse(this.PedidosCli.pedSerasa);
                    }

                    if (this.PedidosCli.pedJusBrasil != '' && this.PedidosCli.pedJusBrasil != null) {
                        const cleanedJson = this.PedidosCli.pedJusBrasil
                            .replace(/,\s*}/g, '}')
                            .replace(/,\s*]/g, ']');

                        const parsedData = JSON.parse(cleanedJson);

                        // Filtrar processos mantendo apenas aqueles que tenham o nome nas partes como EXECUTADO ou REU
                        let nomeFiltro = "";
                        // Filtrar processos mantendo apenas aqueles que tenham o nome nas partes como EXECUTADO ou REU
                        if (parsedData.nome != null && parsedData.nome != ''){
                            nomeFiltro = parsedData.nome.toLowerCase();
                        }

                         this.ListaJusBrasil2 = parsedData;
                    }


                    if (this.PedidosCli.pedInvoiceId != '' && this.PedidosCli.pedInvoiceId != null && this.PedidosCli.pedInvoiceId != '-'){
                        this.ListaInvoice = JSON.parse(this.PedidosCli.pedInvoiceId);
                        //  console.log('this.Cliente')
                        //  console.log(this.Cliente)
                    }


                    axios.get(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetByIdClientes/` + this.PedidosCli.cliId)
                    .then(response => {
                        this.Cliente = response.data;
                        this.ConsultasCliente = [];
                        this.completaConsultasPedidoAtual('ConsultasCliente', this.limparDocumento(this.Cliente.cliDocumento));
                        this.completaConsultasClienteAvulsas();
                        this.CarregaConsultasDocumento(this.Cliente.cliDocumento, 'ConsultasCliente', true);
                        this.CarregaConsultasDocumento(this.Cliente.cliCpfConjuge, 'ConsultasConjuge');
                        this.CarregaConsultasDocumento(this.Cliente.cliCpfCorresponsavel, 'ConsultasCorresp1');
                        this.CarregaConsultasDocumento(this.Cliente.cliCpfCorresponsavel2, 'ConsultasCorresp2');
                        //  console.log('this.Cliente')
                        //  console.log(this.Cliente)
                    });

                    axios.get(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetByIdImobiliaria/` + this.PedidosCli.imobId)
                        .then(response => {
                            this.Imobiliaria = response.data;
                            //  console.log('this.Imobiliaria')
                            //  console.log(this.Imobiliaria)
                     });

                     axios.get(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetByIdGarantidoras/` + this.PedidosCli.garId)
                        .then(response => {
                            this.DadosGarantidora = response.data;
                            //  console.log('this.Imobiliaria')
                            //  console.log(this.Imobiliaria)
                     });

                     axios.get('/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetAllByPedIdDocAnaliseHist/' + this.PedidosCli.pedId)
                        .then(response => {
                            this.ListDocumentos = response.data;
                        })
                        .catch(error => {
                            console.error(error);
                        });

                        axios.get(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetAllModelosContrato`)
                        .then(response => {
                            this.ListaContratos = response.data.filter(x=> x.tpeId == 1 && x.cmcAtivo);
                        });

                        axios.get('/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetAllByPedIdPedidoDocumentoHist/' + this.PedidosCli.pedId)
                        .then(response => {
                            this.ListDocumentosAss = response.data;
                           /* if (this.ListDocumentosAss != '' && this.ListDocumentosAss != null){
                                this.ListDocumentosAssinado = JSON.parse(this.ListDocumentosAss[0]);
                                //  console.log('this.Cliente')
                                //  console.log(this.Cliente)
                            }*/
                        })
                        .catch(error => {
                            console.error(error);
                        });
                   
                         this.CarregaDocs(this.PedidosCli.cliId);
                    this.CarregaConsultas(this.PedidosCli.cliId);

                });

            await axios.get('/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetAllByPedIdPedidoItemHist/' + this.PedidosCli.pedId)
                .then(response => {
                    this.ListaPedidoItem = response.data;

                    this.ListaPedidoItem = this.ListaPedidoItem.map(produto => ({
                        ...produto,
                        pdiDataVigenciaIni: produto.pdiDataVigenciaIni.split('T')[0],
                        pdiDataVigenciaFim: produto.pdiDataVigenciaFim.split('T')[0]
                    }));

                   // console.log('ListaPedidoItem')
                   // console.log(this.ListaPedidoItem)
                })
                .catch(error => {
                    console.error(error);
                });

            await axios.get('/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetAllByPedIdItemAdicionalHist/' + this.PedidosCli.pedId)
                .then(response => {
                    this.ListaPedidoItemAdicional = response.data;
                   // console.log('ListaPedidoItemAdicional')
                   // console.log(this.ListaPedidoItemAdicional)
                })
                .catch(error => {
                    console.error(error);
                });


            axios.get('/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetAllByPedIdEnderecoHist/' + this.PedidosCli.pedId)
                .then(response => {
                    this.PedidosEndereco = response.data;
                   // console.log('PedidosEndereco')
                   // console.log(this.PedidosEndereco)
                })
                .catch(error => {
                    console.error(error);
                });

                axios.get('/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetAllByPedIdComprovaPgtoHist/' + this.PedidosCli.pedId)
                .then(response => {
                    this.PedidosComprova = response.data;
                   // console.log('PedidosComprova')
                   // console.log(this.PedidosComprova)
                })
                .catch(error => {
                    console.error(error);
                });


            axios.get(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetAllSituacaoPedido`)
                .then(response => {
                    this.Situacoes = response.data; //.filter(x=> x.pspId != 1 &&  x.pspId != 3 &&  x.pspId != 5 &&  x.pspId != 6);
                   // console.log('this.Situacoes')
                   // console.log(this.Situacoes)
                });

                axios.get(`/Telas/ContratacoesVigenciaFinalizadaDetalhe/GetAllProdutoImagens`)
                        .then(response => {
                            this.ListaProdutosImg = response.data;
                              //console.log('this.ListaProdutosImg')
                              //console.log(this.ListaProdutosImg)
                     });

         

            this.calculatotal();
        }
    },
    created() {
        this.Get();
    },
    computed: {
    analisesCredito() {
      return [
        {
            titulo: 'Cliente',
            nome: this.Cliente.cliNomeEmpresa,
            documento: this.Cliente.cliDocumento,
            consultas: this.ConsultasCliente,
        },
        {
            titulo: 'Cônjuge',
            nome: this.Cliente.cliNomeConjuge,
            documento: this.Cliente.cliCpfConjuge,
            consultas: this.ConsultasConjuge,
        },
        {
            titulo: 'Corresponsável',
            nome: this.Cliente.cliNomeCorresponsavel,
            documento: this.Cliente.cliCpfCorresponsavel,
            consultas: this.ConsultasCorresp1,
        },
        {
            titulo: 'Corresponsável 2',
            nome: this.Cliente.cliNomeCorresponsavel2,
            documento: this.Cliente.cliCpfCorresponsavel2,
            consultas: this.ConsultasCorresp2,
        },
      ];
    },
    uniqueDocumentos() {
      // Cria uma lista única com base em `pmsNome`
      const seen = new Set();
      return this.ListDocumentos.filter(option => {
        const isDuplicate = seen.has(option.pmsNome);
        seen.add(option.pmsNome);
        return !isDuplicate;
      });
    },
  },
}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}


td {
    /*border: 1px solid #333333;*/
    padding: 3px;
}

@media (min-width:1200px) {
    .controlcelEnd {
    height: 600px;
        width: calc(100% - 248px) !important;
        display: flex;
        flex-direction: column;
    }

}

.bg-custom-white {
    background-color: white;
}

.bg-custom-light-blue {
    background-color: #c5dce7; /* Customize conforme necessário */
}
.gp-finalizada-heading{justify-content:space-between;gap:16px}.gp-finalizada-heading>div{display:flex;flex-direction:column;gap:2px}.gp-finalizada-heading .card-title{margin:0;color:#102a5a;font-size:15px;font-weight:800}.gp-finalizada-heading small{color:#718096;font-size:10px}.gp-finalizada-heading>div>span{display:flex;align-items:center;gap:4px;color:#667085;font-size:9.5px}.gp-finalizada-status{display:inline-flex;align-items:center;gap:5px;padding:6px 10px;border-radius:999px;background:#fff0dd;color:#a95700;font-size:9.5px;font-weight:800;white-space:nowrap}
.gp-finalizada-overview{padding:14px 16px 0}.gp-finalizada-overview-main{display:grid;grid-template-columns:1.15fr 1.15fr .8fr .8fr;gap:9px}.gp-finalizada-overview-main>div{position:relative;display:flex;min-height:68px;flex-direction:column;justify-content:center;padding:10px 12px;border:1px solid #e5ddd2;border-radius:11px;background:#fff}.gp-finalizada-overview-main small,.gp-finalizada-product-config small,.gp-finalizada-payment-summary small{color:#718096;font-size:8px;font-weight:800;text-transform:uppercase}.gp-finalizada-overview-main strong{color:#102a5a;font-size:11px}.gp-finalizada-overview-main span{color:#68758a;font-size:9px}.gp-finalizada-value{color:#087c47!important;font-size:14px!important}.gp-finalizada-access{padding-right:42px!important}.gp-finalizada-access button{position:absolute;right:10px;top:50%;display:grid;width:28px;height:28px;place-items:center;transform:translateY(-50%);border:1px solid #bcd3f6;border-radius:8px;background:#fff;color:#075dcc}
.gp-finalizada-context-grid{display:grid;grid-template-columns:.78fr 1.22fr;gap:9px;margin-top:9px}.gp-finalizada-context-grid>article{display:flex;min-height:105px;flex-direction:column;gap:4px;padding:11px 12px;border:1px solid #e5ddd2;border-radius:11px;background:#fff}.gp-finalizada-context-grid article>header{display:flex;align-items:center;gap:6px;padding-bottom:7px;border-bottom:1px dashed #e6ddd1;color:#102a5a;font-size:10.5px}.gp-finalizada-context-grid article>strong{margin-top:3px;color:#21314e;font-size:10px}.gp-finalizada-context-grid article>span,.gp-finalizada-context-grid article>small{color:#68758a;font-size:8.5px}.gp-finalizada-product-row{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:7px 0;border-bottom:1px dashed #eee6db}.gp-finalizada-product-row>div:first-child{display:flex;flex-direction:column}.gp-finalizada-product-row>div:first-child strong{color:#21314e;font-size:9.5px}.gp-finalizada-product-row>div:first-child span{font-size:8px}.gp-finalizada-product-config{display:flex;gap:7px}.gp-finalizada-product-config>span{display:flex;min-width:68px;flex-direction:column;padding:5px 7px;border:1px solid #e3dbd0;border-radius:8px}.gp-finalizada-product-config strong{color:#102a5a;font-size:9px}.gp-finalizada-additionals{display:flex;flex-wrap:wrap;gap:4px;padding-top:7px}.gp-finalizada-additionals span{padding:3px 6px;border-radius:999px;background:#f1f4f8;color:#4d5d76!important;font-size:7.5px!important}
.gp-finalizada-section-nav{display:flex;gap:5px;margin-top:10px;padding:7px;border:1px solid #e5ddd2;border-radius:11px;background:#faf8f5}.gp-finalizada-section-nav button{display:inline-flex;align-items:center;gap:5px;min-height:31px;padding:5px 10px;border:0;border-radius:8px;background:transparent;color:#526078;font-size:9.5px;font-weight:700}.gp-finalizada-section-nav button.is-active{background:#fff;color:#102a5a;box-shadow:0 2px 8px rgba(16,42,90,.08)}
.gp-finalizada-panels{padding:12px 16px 0}.gp-finalizada-read-panel,.gp-finalizada-analysis-card{overflow:hidden;border:1px solid #e5ddd2;border-radius:12px;background:#fff}.gp-finalizada-read-panel>header{display:flex;align-items:center;gap:9px;padding:11px 13px;border-bottom:1px solid #e9e2d8;background:#fcfaf7}.gp-finalizada-read-panel>header>span{display:grid;width:31px;height:31px;place-items:center;border-radius:9px;background:#fff0dd;color:#e77900}.gp-finalizada-read-panel>header>div{display:flex;flex:1;flex-direction:column}.gp-finalizada-read-panel>header strong{color:#102a5a;font-size:11px}.gp-finalizada-read-panel>header small{color:#748096;font-size:8.5px}.gp-finalizada-read-panel>header em{display:inline-flex;align-items:center;gap:4px;color:#718096;font-size:8px;font-style:normal}.gp-finalizada-observations{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;padding:12px}.gp-finalizada-observations article{min-height:92px;padding:10px;border:1px solid #e8e1d7;border-radius:9px;background:#faf9f7}.gp-finalizada-observations small{color:#68758a;font-size:8px;font-weight:800;text-transform:uppercase}.gp-finalizada-observations p{margin:6px 0 0;color:#344258;font-size:9.5px;line-height:1.5;white-space:pre-wrap}
.gp-finalizada-contract-list,.gp-finalizada-document-list{display:flex;flex-direction:column;padding:10px 12px}.gp-finalizada-contract-list>div,.gp-finalizada-document-list>div{display:flex;align-items:center;gap:8px;min-height:47px;padding:7px 9px;border-bottom:1px solid #eee7dd}.gp-finalizada-contract-list>div>div,.gp-finalizada-document-list>div>div{display:flex;flex:1;flex-direction:column}.gp-finalizada-contract-list strong,.gp-finalizada-document-list strong{flex:1;color:#26354e;font-size:9.5px}.gp-finalizada-contract-list small,.gp-finalizada-document-list small{color:#718096;font-size:8px}.gp-finalizada-contract-list button,.gp-finalizada-document-list button,.gp-finalizada-analysis-card footer button{display:inline-flex;align-items:center;gap:4px;padding:5px 8px;border:1px solid #bad2f5;border-radius:7px;background:#fff;color:#075dcc;font-size:8.5px;font-weight:700}.gp-finalizada-payment-summary{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;padding:12px}.gp-finalizada-payment-summary article{display:flex;min-height:65px;flex-direction:column;justify-content:center;padding:9px 11px;border:1px solid #e8e1d7;border-radius:9px}.gp-finalizada-payment-summary strong{color:#102a5a;font-size:10.5px}.gp-finalizada-payment-summary span{color:#718096;font-size:8.5px}.gp-finalizada-empty{display:flex;min-height:100px;align-items:center;justify-content:center;flex-direction:column;gap:5px;color:#8390a3;font-size:9px}
.gp-finalizada-analysis-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:8px}.gp-finalizada-analysis-card{display:flex;align-items:center;flex-direction:column;padding-bottom:10px}.gp-finalizada-analysis-card>header{display:flex;width:100%;align-items:center;justify-content:space-between;padding:9px 10px;border-bottom:1px solid #e9e2d8;background:#fcfaf7}.gp-finalizada-analysis-card>header strong{color:#102a5a;font-size:10px}.gp-finalizada-analysis-card>header span{color:#718096;font-size:7.5px}.gp-finalizada-analysis-card>div{display:flex;align-items:center;flex-direction:column;padding-top:8px}.gp-finalizada-analysis-card>div strong{color:#26354e;font-size:9px;text-align:center}.gp-finalizada-analysis-card>div small{color:#718096;font-size:8px}.gp-finalizada-analysis-card footer{display:flex;flex-wrap:wrap;justify-content:center;gap:4px}.gp-finalizada-actions{display:flex;justify-content:flex-end;gap:8px;margin-top:12px;padding:11px 16px;border-top:1px solid #e7dfd5;background:#fcfaf7}.gp-finalizada-actions button{display:inline-flex;align-items:center;gap:5px;min-height:34px;padding:7px 12px;border-radius:9px;font-size:9.5px;font-weight:800}.gp-finalizada-actions .is-renew{border:0;background:#e77900;color:#fff}.gp-finalizada-actions .is-close{border:1px solid #dc3545;background:#fff;color:#c82333}
.gp-contract-detail-card{overflow:hidden;border:1px solid #e1d9cd;border-radius:14px}.gp-contract-detail-card>.card-header{padding:13px 17px}.gp-contract-detail-card>.card-body{padding:0}.gp-contract-detail-card :deep(.gp-client-tabs){padding:8px 14px 0;border-bottom:1px solid #e8e1d7;background:#fcfaf7}.gp-contract-detail-card :deep(.v-tab){gap:6px;font-size:11px!important;font-weight:700}.gp-contract-detail-card :deep(.v-window-item>.v-form>.v-container){max-width:none;padding:16px}.gp-contract-detail-card :deep(.v-card){padding:15px!important;border:1px solid #e1d9cd!important;border-radius:12px!important;background:#fff!important;color:#4d586d!important;box-shadow:none!important}.gp-contract-detail-card :deep(h5.subtitulo){display:flex;align-items:center;min-height:38px;margin:-15px -15px 14px!important;padding:11px 15px!important;border-bottom:1px solid #e8e1d7;background:#fcfaf7;color:#102a5a;font-size:13px!important;font-weight:800}.gp-contract-detail-card :deep(.texto-mensagem),.gp-contract-detail-card :deep(.pedido_dados){margin-bottom:6px!important;color:#4d586d!important;font-size:11.5px!important;line-height:1.45}.gp-contract-detail-card :deep(.pedido_dados .v-icon){margin-left:4px;color:#1d4f9f;cursor:pointer}.gp-contract-detail-card :deep(.descricao-pedido){border-color:#eee7dd!important}.gp-contract-detail-card :deep(.descricao-img img){max-height:92px;border:1px solid #e8e1d7!important;border-radius:10px!important;object-fit:contain}.gp-contract-detail-card :deep(.v-table){overflow:hidden;margin:10px 0;border:1px solid #e8e1d7;border-radius:10px;font-size:10.5px}.gp-contract-detail-card :deep(.v-table th){background:#f1ede7;color:#42506a;font-size:9px;font-weight:800;text-transform:uppercase}.gp-contract-detail-card :deep(.v-field),.gp-contract-detail-card :deep(.form-control){border-radius:9px;font-size:11.5px}.gp-contract-detail-card :deep(textarea.form-control){min-height:72px;resize:vertical;background:#faf9f7}.gp-contract-detail-card :deep(.btn){min-height:34px;padding:7px 13px!important;border:0;border-radius:9px;font-size:11px!important;font-weight:700;box-shadow:none}.gp-contract-detail-card :deep(.btn-info){background:#3fa7f5;color:#fff!important}.gp-contract-detail-card :deep(.btn-success){background:#e77900;color:#fff!important}.gp-contract-detail-card :deep(.btn-danger){background:#dc3545;color:#fff!important}
.gp-contract-detail-dialog :deep(.v-overlay__content){width:min(1160px,calc(100vw - 36px))!important;max-width:1160px!important;margin:18px!important}.gp-contract-detail-dialog :deep(.v-overlay__content>.v-card){overflow:hidden;border:1px solid #e1d9cd;border-radius:14px;background:#fff;box-shadow:0 18px 50px rgba(16,42,90,.2)}.gp-contract-detail-dialog :deep(.v-card-title){display:flex;align-items:center;min-height:56px;padding:13px 18px!important;border-bottom:1px solid #e8e1d7;background:#fcfaf7!important;color:#102a5a}.gp-contract-detail-dialog :deep(.v-card-title .text-h5){font-size:14px!important;font-weight:800}.gp-contract-detail-dialog :deep(.v-card-text){max-height:72vh;overflow:auto;padding:16px 18px!important;color:#4d586d}.gp-contract-detail-dialog :deep(.v-card-text>.v-form>.v-container),.gp-contract-detail-dialog :deep(.v-card-text>.v-container){max-width:none;padding:0}.gp-contract-detail-dialog :deep(.v-col){font-size:11px}.gp-contract-detail-dialog :deep(.v-table){overflow:hidden;border:1px solid #e8e1d7;border-radius:10px;font-size:10px}.gp-contract-detail-dialog :deep(.v-table th){background:#f1ede7;color:#42506a;font-size:9px;text-transform:uppercase}.gp-contract-detail-dialog :deep(.v-card-actions){gap:8px;min-height:58px;padding:11px 18px!important;border-top:1px solid #e8e1d7;background:#fcfaf7}.gp-contract-detail-dialog :deep(.v-card-actions .v-btn){min-height:34px;padding:0 13px;border:1px solid #9ba4b0;border-radius:9px;background:#fff;color:#4f5b6d;font-size:10.5px;font-weight:700}.gp-contract-detail-dialog :deep(.v-card-actions .v-btn:first-of-type:not(:last-of-type)){border-color:#e77900;background:#e77900;color:#fff}
@media(min-width:1200px){.controlcelEnd.gp-contract-detail-dialog{width:auto!important;height:auto}}
@media(max-width:767.98px){.gp-contract-detail-card :deep(.v-window-item>.v-form>.v-container){padding:10px}.gp-contract-detail-card :deep(.v-card){padding:13px!important}.gp-contract-detail-card :deep(h5.subtitulo){margin:-13px -13px 12px!important}.gp-contract-detail-dialog :deep(.v-overlay__content){width:calc(100vw - 20px)!important;margin:10px!important}.gp-contract-detail-dialog :deep(.v-card-text){max-height:75vh;padding:12px!important}.gp-contract-detail-dialog :deep(.v-col[style*="border-right"]){border-right:0!important}.gp-contract-detail-dialog :deep(.v-card-actions){align-items:stretch;flex-direction:column}.gp-contract-detail-dialog :deep(.v-card-actions .v-btn){width:100%}}
@media(max-width:991.98px){.gp-finalizada-overview-main{grid-template-columns:repeat(2,minmax(0,1fr))}.gp-finalizada-context-grid{grid-template-columns:1fr}.gp-finalizada-analysis-grid{grid-template-columns:repeat(2,minmax(0,1fr))}.gp-finalizada-section-nav{overflow-x:auto}.gp-finalizada-section-nav button{white-space:nowrap}}
@media(max-width:575.98px){.gp-finalizada-overview{padding:10px 10px 0}.gp-finalizada-overview-main{grid-template-columns:1fr}.gp-finalizada-product-row{align-items:flex-start;flex-direction:column}.gp-finalizada-product-config{width:100%;flex-wrap:wrap}.gp-finalizada-product-config>span{flex:1}.gp-finalizada-panels{padding:10px 10px 0}.gp-finalizada-analysis-grid,.gp-finalizada-observations,.gp-finalizada-payment-summary{grid-template-columns:1fr}.gp-finalizada-read-panel>header em{display:none}.gp-finalizada-actions{align-items:stretch;flex-direction:column}.gp-finalizada-actions button{justify-content:center;width:100%}}

</style>

